export default [
  {
    name: "Ser",
    en: "to be",
    conjugations: {
      present: {
        yo: {
          conjugation: "soy",
          enExample: "I am a teacher.",
          esExample: "Soy profesor.",
          audio: "",
        },
        tú: {
          conjugation: "eres",
          enExample: "You are happy.",
          esExample: "Tú eres feliz.",
          audio: "",
        },
        él: {
          conjugation: "es",
          enExample: "He is at home.",
          esExample: "Él está en casa.",
          audio: "",
        },
        nosotros: {
          conjugation: "somos",
          enExample: "We are friends.",
          esExample: "Nosotros somos amigos.",
          audio: "",
        },
        vosotros: {
          conjugation: "sois",
          enExample: "You all are tired.",
          esExample: "Vosotros sois cansados.",
          audio: "",
        },
        ellos: {
          conjugation: "son",
          enExample: "They are doctors.",
          esExample: "Ellos son doctores.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "fui",
          enExample: "I was happy.",
          esExample: "Yo fui feliz.",
          audio: "",
        },
        tú: {
          conjugation: "fuiste",
          enExample: "You were tired.",
          esExample: "Tú fuiste cansado.",
          audio: "",
        },
        él: {
          conjugation: "fue",
          enExample: "He was here.",
          esExample: "Él fue aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "fuimos",
          enExample: "We were there.",
          esExample: "Nosotros fuimos allí.",
          audio: "",
        },
        vosotros: {
          conjugation: "fuisteis",
          enExample: "You all were at the party.",
          esExample: "Vosotros fuisteis a la fiesta.",
          audio: "",
        },
        ellos: {
          conjugation: "fueron",
          enExample: "They were happy.",
          esExample: "Ellos fueron felices.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "era",
          enExample: "I was doing my homework.",
          esExample: "Yo era haciendo mi tarea.",
          audio: "",
        },
        tú: {
          conjugation: "eras",
          enExample: "You were eating.",
          esExample: "Tú eras comiendo.",
          audio: "",
        },
        él: {
          conjugation: "era",
          enExample: "He was working.",
          esExample: "Él era trabajando.",
          audio: "",
        },
        nosotros: {
          conjugation: "éramos",
          enExample: "We were talking.",
          esExample: "Nosotros éramos hablando.",
          audio: "",
        },
        vosotros: {
          conjugation: "erais",
          enExample: "You all were playing.",
          esExample: "Vosotros erais jugando.",
          audio: "",
        },
        ellos: {
          conjugation: "eran",
          enExample: "They were studying.",
          esExample: "Ellos eran estudiando.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "seré",
          enExample: "I will be at home.",
          esExample: "Yo seré en casa.",
          audio: "",
        },
        tú: {
          conjugation: "serás",
          enExample: "You will be happy.",
          esExample: "Tú serás feliz.",
          audio: "",
        },
        él: {
          conjugation: "será",
          enExample: "He will be here.",
          esExample: "Él será aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "seremos",
          enExample: "We will be there.",
          esExample: "Nosotros seremos allí.",
          audio: "",
        },
        vosotros: {
          conjugation: "seréis",
          enExample: "You all will be tired.",
          esExample: "Vosotros seréis cansados.",
          audio: "",
        },
        ellos: {
          conjugation: "serán",
          enExample: "They will be doctors.",
          esExample: "Ellos serán doctores.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "sería",
          enExample: "I would be surprised.",
          esExample: "Yo sería sorprendido.",
          audio: "",
        },
        tú: {
          conjugation: "serías",
          enExample: "You would be excited.",
          esExample: "Tú serías emocionado.",
          audio: "",
        },
        él: {
          conjugation: "sería",
          enExample: "He would be here.",
          esExample: "Él sería aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "seríamos",
          enExample: "We would be happy.",
          esExample: "Nosotros seríamos felices.",
          audio: "",
        },
        vosotros: {
          conjugation: "seríais",
          enExample: "You all would be tired.",
          esExample: "Vosotros seríais cansados.",
          audio: "",
        },
        ellos: {
          conjugation: "serían",
          enExample: "They would be successful.",
          esExample: "Ellos serían exitosos.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "sea",
          enExample: "I hope I am on time.",
          esExample: "Espero que sea puntual.",
          audio: "",
        },
        tú: {
          conjugation: "seas",
          enExample: "I hope you are happy.",
          esExample: "Espero que seas feliz.",
          audio: "",
        },
        él: {
          conjugation: "sea",
          enExample: "I hope he is here.",
          esExample: "Espero que él sea aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "seamos",
          enExample: "I hope we are healthy.",
          esExample: "Espero que seamos saludables.",
          audio: "",
        },
        vosotros: {
          conjugation: "seáis",
          enExample: "I hope you all are here.",
          esExample: "Espero que vosotros seáis aquí.",
          audio: "",
        },
        ellos: {
          conjugation: "sean",
          enExample: "I hope they are happy.",
          esExample: "Espero que ellos sean felices.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Estar",
    en: "to be (temporary)",
    conjugations: {
      present: {
        yo: {
          conjugation: "estoy",
          enExample: "I am at the store.",
          esExample: "Estoy en la tienda.",
          audio: "",
        },
        tú: {
          conjugation: "estás",
          enExample: "You are here.",
          esExample: "Tú estás aquí.",
          audio: "",
        },
        él: {
          conjugation: "está",
          enExample: "He is at home.",
          esExample: "Él está en casa.",
          audio: "",
        },
        nosotros: {
          conjugation: "estamos",
          enExample: "We are here.",
          esExample: "Nosotros estamos aquí.",
          audio: "",
        },
        vosotros: {
          conjugation: "estáis",
          enExample: "You all are here.",
          esExample: "Vosotros estáis aquí.",
          audio: "",
        },
        ellos: {
          conjugation: "están",
          enExample: "They are here.",
          esExample: "Ellos están aquí.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "estuve",
          enExample: "I was tired.",
          esExample: "Yo estuve cansado.",
          audio: "",
        },
        tú: {
          conjugation: "estuviste",
          enExample: "You were here.",
          esExample: "Tú estuviste aquí.",
          audio: "",
        },
        él: {
          conjugation: "estuvo",
          enExample: "He was happy.",
          esExample: "Él estuvo feliz.",
          audio: "",
        },
        nosotros: {
          conjugation: "estuvimos",
          enExample: "We were there.",
          esExample: "Nosotros estuvimos allí.",
          audio: "",
        },
        vosotros: {
          conjugation: "estuvisteis",
          enExample: "You all were tired.",
          esExample: "Vosotros estuvisteis cansados.",
          audio: "",
        },
        ellos: {
          conjugation: "estuvieron",
          enExample: "They were happy.",
          esExample: "Ellos estuvieron felices.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "estaba",
          enExample: "I was doing my work.",
          esExample: "Yo estaba haciendo mi trabajo.",
          audio: "",
        },
        tú: {
          conjugation: "estabas",
          enExample: "You were playing.",
          esExample: "Tú estabas jugando.",
          audio: "",
        },
        él: {
          conjugation: "estaba",
          enExample: "He was cooking.",
          esExample: "Él estaba cocinando.",
          audio: "",
        },
        nosotros: {
          conjugation: "estábamos",
          enExample: "We were studying.",
          esExample: "Nosotros estábamos estudiando.",
          audio: "",
        },
        vosotros: {
          conjugation: "estabais",
          enExample: "You all were sleeping.",
          esExample: "Vosotros estabais durmiendo.",
          audio: "",
        },
        ellos: {
          conjugation: "estaban",
          enExample: "They were eating.",
          esExample: "Ellos estaban comiendo.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "estaré",
          enExample: "I will be ready soon.",
          esExample: "Estaré listo pronto.",
          audio: "",
        },
        tú: {
          conjugation: "estarás",
          enExample: "You will be at work.",
          esExample: "Tú estarás en el trabajo.",
          audio: "",
        },
        él: {
          conjugation: "estará",
          enExample: "He will be here.",
          esExample: "Él estará aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "estaremos",
          enExample: "We will be happy.",
          esExample: "Nosotros estaremos felices.",
          audio: "",
        },
        vosotros: {
          conjugation: "estaréis",
          enExample: "You all will be here.",
          esExample: "Vosotros estaréis aquí.",
          audio: "",
        },
        ellos: {
          conjugation: "estarán",
          enExample: "They will be at the store.",
          esExample: "Ellos estarán en la tienda.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "estaría",
          enExample: "I would be happy to help.",
          esExample: "Estaría feliz de ayudar.",
          audio: "",
        },
        tú: {
          conjugation: "estarías",
          enExample: "You would be tired.",
          esExample: "Tú estarías cansado.",
          audio: "",
        },
        él: {
          conjugation: "estaría",
          enExample: "He would be upset.",
          esExample: "Él estaría molesto.",
          audio: "",
        },
        nosotros: {
          conjugation: "estaríamos",
          enExample: "We would be fine.",
          esExample: "Nosotros estaríamos bien.",
          audio: "",
        },
        vosotros: {
          conjugation: "estaríais",
          enExample: "You all would be surprised.",
          esExample: "Vosotros estaríais sorprendidos.",
          audio: "",
        },
        ellos: {
          conjugation: "estarían",
          enExample: "They would be here soon.",
          esExample: "Ellos estarían aquí pronto.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "esté",
          enExample: "I hope I am healthy.",
          esExample: "Espero que esté saludable.",
          audio: "",
        },
        tú: {
          conjugation: "estés",
          enExample: "I hope you are okay.",
          esExample: "Espero que estés bien.",
          audio: "",
        },
        él: {
          conjugation: "esté",
          enExample: "I hope he is here.",
          esExample: "Espero que él esté aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "estemos",
          enExample: "I hope we are happy.",
          esExample: "Espero que estemos felices.",
          audio: "",
        },
        vosotros: {
          conjugation: "estéis",
          enExample: "I hope you all are fine.",
          esExample: "Espero que vosotros estéis bien.",
          audio: "",
        },
        ellos: {
          conjugation: "estén",
          enExample: "I hope they are okay.",
          esExample: "Espero que ellos estén bien.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Tener",
    en: "to have",
    conjugations: {
      present: {
        yo: {
          conjugation: "tengo",
          enExample: "I have two dogs.",
          esExample: "Tengo dos perros.",
          audio: "",
        },
        tú: {
          conjugation: "tienes",
          enExample: "You have a cat.",
          esExample: "Tú tienes un gato.",
          audio: "",
        },
        él: {
          conjugation: "tiene",
          enExample: "He has a car.",
          esExample: "Él tiene un coche.",
          audio: "",
        },
        nosotros: {
          conjugation: "tenemos",
          enExample: "We have a house.",
          esExample: "Nosotros tenemos una casa.",
          audio: "",
        },
        vosotros: {
          conjugation: "tenéis",
          enExample: "You all have tickets.",
          esExample: "Vosotros tenéis entradas.",
          audio: "",
        },
        ellos: {
          conjugation: "tienen",
          enExample: "They have a plan.",
          esExample: "Ellos tienen un plan.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "tuve",
          enExample: "I had a great time.",
          esExample: "Yo tuve un buen rato.",
          audio: "",
        },
        tú: {
          conjugation: "tuviste",
          enExample: "You had a good meal.",
          esExample: "Tú tuviste una buena comida.",
          audio: "",
        },
        él: {
          conjugation: "tuvo",
          enExample: "He had a meeting.",
          esExample: "Él tuvo una reunión.",
          audio: "",
        },
        nosotros: {
          conjugation: "tuvimos",
          enExample: "We had fun.",
          esExample: "Nosotros tuvimos diversión.",
          audio: "",
        },
        vosotros: {
          conjugation: "tuvisteis",
          enExample: "You all had enough time.",
          esExample: "Vosotros tuvisteis suficiente tiempo.",
          audio: "",
        },
        ellos: {
          conjugation: "tuvieron",
          enExample: "They had everything ready.",
          esExample: "Ellos tuvieron todo listo.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "tenía",
          enExample: "I was having lunch.",
          esExample: "Yo tenía almuerzo.",
          audio: "",
        },
        tú: {
          conjugation: "tenías",
          enExample: "You were having fun.",
          esExample: "Tú tenías diversión.",
          audio: "",
        },
        él: {
          conjugation: "tenía",
          enExample: "He was having a conversation.",
          esExample: "Él tenía una conversación.",
          audio: "",
        },
        nosotros: {
          conjugation: "teníamos",
          enExample: "We were having a good time.",
          esExample: "Nosotros teníamos un buen rato.",
          audio: "",
        },
        vosotros: {
          conjugation: "teníais",
          enExample: "You all were having dinner.",
          esExample: "Vosotros teníais la cena.",
          audio: "",
        },
        ellos: {
          conjugation: "tenían",
          enExample: "They were having a problem.",
          esExample: "Ellos tenían un problema.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "tendré",
          enExample: "I will have a meeting later.",
          esExample: "Tendré una reunión más tarde.",
          audio: "",
        },
        tú: {
          conjugation: "tendrás",
          enExample: "You will have more time tomorrow.",
          esExample: "Tú tendrás más tiempo mañana.",
          audio: "",
        },
        él: {
          conjugation: "tendrá",
          enExample: "He will have a break soon.",
          esExample: "Él tendrá un descanso pronto.",
          audio: "",
        },
        nosotros: {
          conjugation: "tendremos",
          enExample: "We will have a party.",
          esExample: "Nosotros tendremos una fiesta.",
          audio: "",
        },
        vosotros: {
          conjugation: "tendréis",
          enExample: "You all will have a holiday next month.",
          esExample: "Vosotros tendréis un día festivo el próximo mes.",
          audio: "",
        },
        ellos: {
          conjugation: "tendrán",
          enExample: "They will have everything ready.",
          esExample: "Ellos tendrán todo listo.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "tendría",
          enExample: "I would have more time if I worked less.",
          esExample: "Tendría más tiempo si trabajara menos.",
          audio: "",
        },
        tú: {
          conjugation: "tendrías",
          enExample: "You would have a better job.",
          esExample: "Tú tendrías un mejor trabajo.",
          audio: "",
        },
        él: {
          conjugation: "tendría",
          enExample: "He would have more money if he saved.",
          esExample: "Él tendría más dinero si ahorrara.",
          audio: "",
        },
        nosotros: {
          conjugation: "tendríamos",
          enExample: "We would have more fun.",
          esExample: "Nosotros tendríamos más diversión.",
          audio: "",
        },
        vosotros: {
          conjugation: "tendríais",
          enExample: "You all would have a good time.",
          esExample: "Vosotros tendríais un buen rato.",
          audio: "",
        },
        ellos: {
          conjugation: "tendrían",
          enExample: "They would have a solution.",
          esExample: "Ellos tendrían una solución.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "tenga",
          enExample: "I hope I have a good weekend.",
          esExample: "Espero que tenga un buen fin de semana.",
          audio: "",
        },
        tú: {
          conjugation: "tengas",
          enExample: "I hope you have enough time.",
          esExample: "Espero que tengas suficiente tiempo.",
          audio: "",
        },
        él: {
          conjugation: "tenga",
          enExample: "I hope he has the right answer.",
          esExample: "Espero que él tenga la respuesta correcta.",
          audio: "",
        },
        nosotros: {
          conjugation: "tengamos",
          enExample: "I hope we have fun.",
          esExample: "Espero que tengamos diversión.",
          audio: "",
        },
        vosotros: {
          conjugation: "tengáis",
          enExample: "I hope you all have a good trip.",
          esExample: "Espero que vosotros tengáis un buen viaje.",
          audio: "",
        },
        ellos: {
          conjugation: "tengan",
          enExample: "I hope they have everything ready.",
          esExample: "Espero que ellos tengan todo listo.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Hacer",
    en: "to do/make",
    conjugations: {
      present: {
        yo: {
          conjugation: "hago",
          enExample: "I do yoga every morning.",
          esExample: "Hago yoga todas las mañanas.",
          audio: "",
        },
        tú: {
          conjugation: "haces",
          enExample: "You make dinner.",
          esExample: "Tú haces la cena.",
          audio: "",
        },
        él: {
          conjugation: "hace",
          enExample: "He makes lunch.",
          esExample: "Él hace el almuerzo.",
          audio: "",
        },
        nosotros: {
          conjugation: "hacemos",
          enExample: "We do our homework.",
          esExample: "Nosotros hacemos nuestra tarea.",
          audio: "",
        },
        vosotros: {
          conjugation: "hacéis",
          enExample: "You all do the dishes.",
          esExample: "Vosotros hacéis los platos.",
          audio: "",
        },
        ellos: {
          conjugation: "hacen",
          enExample: "They make pizza.",
          esExample: "Ellos hacen pizza.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "hice",
          enExample: "I did the dishes.",
          esExample: "Yo hice los platos.",
          audio: "",
        },
        tú: {
          conjugation: "hiciste",
          enExample: "You made a cake.",
          esExample: "Tú hiciste un pastel.",
          audio: "",
        },
        él: {
          conjugation: "hizo",
          enExample: "He made a call.",
          esExample: "Él hizo una llamada.",
          audio: "",
        },
        nosotros: {
          conjugation: "hicimos",
          enExample: "We did a lot of work.",
          esExample: "Nosotros hicimos mucho trabajo.",
          audio: "",
        },
        vosotros: {
          conjugation: "hicisteis",
          enExample: "You all made breakfast.",
          esExample: "Vosotros hicisteis el desayuno.",
          audio: "",
        },
        ellos: {
          conjugation: "hicieron",
          enExample: "They did the homework.",
          esExample: "Ellos hicieron la tarea.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "hacía",
          enExample: "I was doing my homework.",
          esExample: "Yo hacía mi tarea.",
          audio: "",
        },
        tú: {
          conjugation: "hacías",
          enExample: "You were making dinner.",
          esExample: "Tú hacías la cena.",
          audio: "",
        },
        él: {
          conjugation: "hacía",
          enExample: "He was working.",
          esExample: "Él hacía trabajo.",
          audio: "",
        },
        nosotros: {
          conjugation: "hacíamos",
          enExample: "We were doing the project.",
          esExample: "Nosotros hacíamos el proyecto.",
          audio: "",
        },
        vosotros: {
          conjugation: "hacíais",
          enExample: "You all were making pizza.",
          esExample: "Vosotros hacíais pizza.",
          audio: "",
        },
        ellos: {
          conjugation: "hacían",
          enExample: "They were making calls.",
          esExample: "Ellos hacían llamadas.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "haré",
          enExample: "I will do it tomorrow.",
          esExample: "Lo haré mañana.",
          audio: "",
        },
        tú: {
          conjugation: "harás",
          enExample: "You will make it soon.",
          esExample: "Tú harás eso pronto.",
          audio: "",
        },
        él: {
          conjugation: "hará",
          enExample: "He will do it later.",
          esExample: "Él hará esto más tarde.",
          audio: "",
        },
        nosotros: {
          conjugation: "haremos",
          enExample: "We will do it later.",
          esExample: "Nosotros haremos esto después.",
          audio: "",
        },
        vosotros: {
          conjugation: "haréis",
          enExample: "You all will do it.",
          esExample: "Vosotros haréis eso.",
          audio: "",
        },
        ellos: {
          conjugation: "harán",
          enExample: "They will do their work.",
          esExample: "Ellos harán su trabajo.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "haría",
          enExample: "I would do it if I had time.",
          esExample: "Lo haría si tuviera tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "harías",
          enExample: "You would make it if you could.",
          esExample: "Lo harías si pudieras.",
          audio: "",
        },
        él: {
          conjugation: "haría",
          enExample: "He would do it if he were here.",
          esExample: "Él lo haría si estuviera aquí.",
          audio: "",
        },
        nosotros: {
          conjugation: "haríamos",
          enExample: "We would do it if we had time.",
          esExample: "Lo haríamos si tuviéramos tiempo.",
          audio: "",
        },
        vosotros: {
          conjugation: "haríais",
          enExample: "You all would do it.",
          esExample: "Vosotros lo haríais.",
          audio: "",
        },
        ellos: {
          conjugation: "harían",
          enExample: "They would make pizza.",
          esExample: "Ellos harían pizza.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "haga",
          enExample: "I hope I do well in the exam.",
          esExample: "Espero que haga bien en el examen.",
          audio: "",
        },
        tú: {
          conjugation: "hagas",
          enExample: "I hope you make it on time.",
          esExample: "Espero que hagas esto a tiempo.",
          audio: "",
        },
        él: {
          conjugation: "haga",
          enExample: "I hope he makes it.",
          esExample: "Espero que él haga esto.",
          audio: "",
        },
        nosotros: {
          conjugation: "hagamos",
          enExample: "I hope we do it right.",
          esExample: "Espero que hagamos esto bien.",
          audio: "",
        },
        vosotros: {
          conjugation: "hagáis",
          enExample: "I hope you all make it.",
          esExample: "Espero que vosotros lo hagáis.",
          audio: "",
        },
        ellos: {
          conjugation: "hagan",
          enExample: "I hope they do well.",
          esExample: "Espero que ellos lo hagan bien.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Poder",
    en: "to be able to / can",
    conjugations: {
      present: {
        yo: {
          conjugation: "puedo",
          enExample: "I can speak Spanish.",
          esExample: "Puedo hablar español.",
          audio: "",
        },
        tú: {
          conjugation: "puedes",
          enExample: "You can swim.",
          esExample: "Tú puedes nadar.",
          audio: "",
        },
        él: {
          conjugation: "puede",
          enExample: "He can drive.",
          esExample: "Él puede conducir.",
          audio: "",
        },
        nosotros: {
          conjugation: "podemos",
          enExample: "We can learn.",
          esExample: "Nosotros podemos aprender.",
          audio: "",
        },
        vosotros: {
          conjugation: "podéis",
          enExample: "You all can help.",
          esExample: "Vosotros podéis ayudar.",
          audio: "",
        },
        ellos: {
          conjugation: "pueden",
          enExample: "They can run fast.",
          esExample: "Ellos pueden correr rápido.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "pude",
          enExample: "I could help you.",
          esExample: "Yo pude ayudarte.",
          audio: "",
        },
        tú: {
          conjugation: "pudiste",
          enExample: "You could come.",
          esExample: "Tú pudiste venir.",
          audio: "",
        },
        él: {
          conjugation: "pudo",
          enExample: "He could see it.",
          esExample: "Él pudo verlo.",
          audio: "",
        },
        nosotros: {
          conjugation: "pudimos",
          enExample: "We could do it.",
          esExample: "Nosotros pudimos hacerlo.",
          audio: "",
        },
        vosotros: {
          conjugation: "pudisteis",
          enExample: "You all could hear it.",
          esExample: "Vosotros pudisteis oírlo.",
          audio: "",
        },
        ellos: {
          conjugation: "pudieron",
          enExample: "They could finish it.",
          esExample: "Ellos pudieron terminarlo.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "podía",
          enExample: "I was able to see it.",
          esExample: "Yo podía verlo.",
          audio: "",
        },
        tú: {
          conjugation: "podías",
          enExample: "You were able to help.",
          esExample: "Tú podías ayudar.",
          audio: "",
        },
        él: {
          conjugation: "podía",
          enExample: "He was able to hear it.",
          esExample: "Él podía oírlo.",
          audio: "",
        },
        nosotros: {
          conjugation: "podíamos",
          enExample: "We were able to do it.",
          esExample: "Nosotros podíamos hacerlo.",
          audio: "",
        },
        vosotros: {
          conjugation: "podíais",
          enExample: "You all were able to come.",
          esExample: "Vosotros podíais venir.",
          audio: "",
        },
        ellos: {
          conjugation: "podían",
          enExample: "They were able to go.",
          esExample: "Ellos podían ir.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "podré",
          enExample: "I will be able to go tomorrow.",
          esExample: "Podré ir mañana.",
          audio: "",
        },
        tú: {
          conjugation: "podrás",
          enExample: "You will be able to speak.",
          esExample: "Tú podrás hablar.",
          audio: "",
        },
        él: {
          conjugation: "podrá",
          enExample: "He will be able to work.",
          esExample: "Él podrá trabajar.",
          audio: "",
        },
        nosotros: {
          conjugation: "podremos",
          enExample: "We will be able to help.",
          esExample: "Nosotros podremos ayudar.",
          audio: "",
        },
        vosotros: {
          conjugation: "podréis",
          enExample: "You all will be able to understand.",
          esExample: "Vosotros podréis entender.",
          audio: "",
        },
        ellos: {
          conjugation: "podrán",
          enExample: "They will be able to finish.",
          esExample: "Ellos podrán terminar.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "podría",
          enExample: "I would be able to help.",
          esExample: "Podría ayudar.",
          audio: "",
        },
        tú: {
          conjugation: "podrías",
          enExample: "You would be able to go.",
          esExample: "Tú podrías ir.",
          audio: "",
        },
        él: {
          conjugation: "podría",
          enExample: "He would be able to work.",
          esExample: "Él podría trabajar.",
          audio: "",
        },
        nosotros: {
          conjugation: "podríamos",
          enExample: "We would be able to travel.",
          esExample: "Nosotros podríamos viajar.",
          audio: "",
        },
        vosotros: {
          conjugation: "podríais",
          enExample: "You all would be able to see.",
          esExample: "Vosotros podríais ver.",
          audio: "",
        },
        ellos: {
          conjugation: "podrían",
          enExample: "They would be able to stay.",
          esExample: "Ellos podrían quedarse.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "pueda",
          enExample: "I hope I can make it.",
          esExample: "Espero que pueda hacerlo.",
          audio: "",
        },
        tú: {
          conjugation: "puedas",
          enExample: "I hope you can come.",
          esExample: "Espero que puedas venir.",
          audio: "",
        },
        él: {
          conjugation: "pueda",
          enExample: "I hope he can help.",
          esExample: "Espero que él pueda ayudar.",
          audio: "",
        },
        nosotros: {
          conjugation: "podamos",
          enExample: "I hope we can do it.",
          esExample: "Espero que podamos hacerlo.",
          audio: "",
        },
        vosotros: {
          conjugation: "podáis",
          enExample: "I hope you all can see it.",
          esExample: "Espero que vosotros podáis verlo.",
          audio: "",
        },
        ellos: {
          conjugation: "puedan",
          enExample: "I hope they can stay.",
          esExample: "Espero que ellos puedan quedarse.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Ver",
    en: "to see",
    conjugations: {
      present: {
        yo: {
          conjugation: "veo",
          enExample: "I see the mountains.",
          esExample: "Veo las montañas.",
          audio: "",
        },
        tú: {
          conjugation: "ves",
          enExample: "You see the stars.",
          esExample: "Tú ves las estrellas.",
          audio: "",
        },
        él: {
          conjugation: "ve",
          enExample: "He sees the ocean.",
          esExample: "Él ve el océano.",
          audio: "",
        },
        nosotros: {
          conjugation: "vemos",
          enExample: "We see the city.",
          esExample: "Nosotros vemos la ciudad.",
          audio: "",
        },
        vosotros: {
          conjugation: "veis",
          enExample: "You all see the birds.",
          esExample: "Vosotros veis los pájaros.",
          audio: "",
        },
        ellos: {
          conjugation: "ven",
          enExample: "They see the cars.",
          esExample: "Ellos ven los coches.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "vi",
          enExample: "I saw the movie.",
          esExample: "Yo vi la película.",
          audio: "",
        },
        tú: {
          conjugation: "viste",
          enExample: "You saw the show.",
          esExample: "Tú viste el espectáculo.",
          audio: "",
        },
        él: {
          conjugation: "vio",
          enExample: "He saw the game.",
          esExample: "Él vio el partido.",
          audio: "",
        },
        nosotros: {
          conjugation: "vimos",
          enExample: "We saw the play.",
          esExample: "Nosotros vimos la obra.",
          audio: "",
        },
        vosotros: {
          conjugation: "visteis",
          enExample: "You all saw the concert.",
          esExample: "Vosotros visteis el concierto.",
          audio: "",
        },
        ellos: {
          conjugation: "vieron",
          enExample: "They saw the exhibition.",
          esExample: "Ellos vieron la exposición.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "veía",
          enExample: "I was seeing the doctor.",
          esExample: "Yo veía al doctor.",
          audio: "",
        },
        tú: {
          conjugation: "veías",
          enExample: "You were seeing the movie.",
          esExample: "Tú veías la película.",
          audio: "",
        },
        él: {
          conjugation: "veía",
          enExample: "He was seeing the teacher.",
          esExample: "Él veía al profesor.",
          audio: "",
        },
        nosotros: {
          conjugation: "veíamos",
          enExample: "We were seeing the sunset.",
          esExample: "Nosotros veíamos el atardecer.",
          audio: "",
        },
        vosotros: {
          conjugation: "veíais",
          enExample: "You all were seeing the concert.",
          esExample: "Vosotros veíais el concierto.",
          audio: "",
        },
        ellos: {
          conjugation: "veían",
          enExample: "They were seeing the movie.",
          esExample: "Ellos veían la película.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "veré",
          enExample: "I will see you tomorrow.",
          esExample: "Te veré mañana.",
          audio: "",
        },
        tú: {
          conjugation: "verás",
          enExample: "You will see the results.",
          esExample: "Tú verás los resultados.",
          audio: "",
        },
        él: {
          conjugation: "verá",
          enExample: "He will see the news.",
          esExample: "Él verá las noticias.",
          audio: "",
        },
        nosotros: {
          conjugation: "veremos",
          enExample: "We will see the project.",
          esExample: "Nosotros veremos el proyecto.",
          audio: "",
        },
        vosotros: {
          conjugation: "veréis",
          enExample: "You all will see the match.",
          esExample: "Vosotros veréis el partido.",
          audio: "",
        },
        ellos: {
          conjugation: "verán",
          enExample: "They will see the concert.",
          esExample: "Ellos verán el concierto.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "vería",
          enExample: "I would see you if I could.",
          esExample: "Te vería si pudiera.",
          audio: "",
        },
        tú: {
          conjugation: "verías",
          enExample: "You would see it if you came.",
          esExample: "Lo verías si vinieras.",
          audio: "",
        },
        él: {
          conjugation: "vería",
          enExample: "He would see the movie if he had time.",
          esExample: "Él vería la película si tuviera tiempo.",
          audio: "",
        },
        nosotros: {
          conjugation: "veríamos",
          enExample: "We would see the play.",
          esExample: "Nosotros veríamos la obra.",
          audio: "",
        },
        vosotros: {
          conjugation: "veríais",
          enExample: "You all would see the concert.",
          esExample: "Vosotros veríais el concierto.",
          audio: "",
        },
        ellos: {
          conjugation: "verían",
          enExample: "They would see the show.",
          esExample: "Ellos verían el espectáculo.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "vea",
          enExample: "I hope I see you soon.",
          esExample: "Espero que vea pronto.",
          audio: "",
        },
        tú: {
          conjugation: "veas",
          enExample: "I hope you see the results.",
          esExample: "Espero que veas los resultados.",
          audio: "",
        },
        él: {
          conjugation: "vea",
          enExample: "I hope he sees it.",
          esExample: "Espero que él vea eso.",
          audio: "",
        },
        nosotros: {
          conjugation: "veamos",
          enExample: "I hope we see the project.",
          esExample: "Espero que veamos el proyecto.",
          audio: "",
        },
        vosotros: {
          conjugation: "veáis",
          enExample: "I hope you all see the match.",
          esExample: "Espero que veáis el partido.",
          audio: "",
        },
        ellos: {
          conjugation: "vean",
          enExample: "I hope they see the exhibition.",
          esExample: "Espero que ellos vean la exposición.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Ir",
    en: "to go",
    conjugations: {
      present: {
        yo: {
          conjugation: "voy",
          enExample: "I go to the gym every day.",
          esExample: "Voy al gimnasio todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "vas",
          enExample: "You go to school.",
          esExample: "Vas a la escuela.",
          audio: "",
        },
        él: {
          conjugation: "va",
          enExample: "He goes to work.",
          esExample: "Él va al trabajo.",
          audio: "",
        },
        nosotros: {
          conjugation: "vamos",
          enExample: "We go to the market.",
          esExample: "Vamos al mercado.",
          audio: "",
        },
        vosotros: {
          conjugation: "vais",
          enExample: "You all go to the park.",
          esExample: "Vosotros vais al parque.",
          audio: "",
        },
        ellos: {
          conjugation: "van",
          enExample: "They go home.",
          esExample: "Ellos van a casa.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "fui",
          enExample: "I went to the beach.",
          esExample: "Yo fui a la playa.",
          audio: "",
        },
        tú: {
          conjugation: "fuiste",
          enExample: "You went to the store.",
          esExample: "Tú fuiste a la tienda.",
          audio: "",
        },
        él: {
          conjugation: "fue",
          enExample: "He went to the party.",
          esExample: "Él fue a la fiesta.",
          audio: "",
        },
        nosotros: {
          conjugation: "fuimos",
          enExample: "We went to the concert.",
          esExample: "Nosotros fuimos al concierto.",
          audio: "",
        },
        vosotros: {
          conjugation: "fuisteis",
          enExample: "You all went to the restaurant.",
          esExample: "Vosotros fuisteis al restaurante.",
          audio: "",
        },
        ellos: {
          conjugation: "fueron",
          enExample: "They went to the cinema.",
          esExample: "Ellos fueron al cine.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "iba",
          enExample: "I was going to the store.",
          esExample: "Yo iba a la tienda.",
          audio: "",
        },
        tú: {
          conjugation: "ibas",
          enExample: "You were going to the party.",
          esExample: "Tú ibas a la fiesta.",
          audio: "",
        },
        él: {
          conjugation: "iba",
          enExample: "He was going to the meeting.",
          esExample: "Él iba a la reunión.",
          audio: "",
        },
        nosotros: {
          conjugation: "íbamos",
          enExample: "We were going to the beach.",
          esExample: "Nosotros íbamos a la playa.",
          audio: "",
        },
        vosotros: {
          conjugation: "ibais",
          enExample: "You all were going to work.",
          esExample: "Vosotros ibais al trabajo.",
          audio: "",
        },
        ellos: {
          conjugation: "iban",
          enExample: "They were going to the concert.",
          esExample: "Ellos iban al concierto.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "iré",
          enExample: "I will go to the party later.",
          esExample: "Iré a la fiesta más tarde.",
          audio: "",
        },
        tú: {
          conjugation: "irás",
          enExample: "You will go to the gym.",
          esExample: "Tú irás al gimnasio.",
          audio: "",
        },
        él: {
          conjugation: "irá",
          enExample: "He will go to the store.",
          esExample: "Él irá a la tienda.",
          audio: "",
        },
        nosotros: {
          conjugation: "iremos",
          enExample: "We will go to the beach.",
          esExample: "Nosotros iremos a la playa.",
          audio: "",
        },
        vosotros: {
          conjugation: "iréis",
          enExample: "You all will go to the park.",
          esExample: "Vosotros iréis al parque.",
          audio: "",
        },
        ellos: {
          conjugation: "irán",
          enExample: "They will go to the concert.",
          esExample: "Ellos irán al concierto.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "iría",
          enExample: "I would go if I could.",
          esExample: "Iría si pudiera.",
          audio: "",
        },
        tú: {
          conjugation: "irías",
          enExample: "You would go if you had time.",
          esExample: "Tú irías si tuvieras tiempo.",
          audio: "",
        },
        él: {
          conjugation: "iría",
          enExample: "He would go if he were invited.",
          esExample: "Él iría si lo invitaran.",
          audio: "",
        },
        nosotros: {
          conjugation: "iríamos",
          enExample: "We would go if we could.",
          esExample: "Nosotros iríamos si pudiéramos.",
          audio: "",
        },
        vosotros: {
          conjugation: "iríais",
          enExample: "You all would go if it were possible.",
          esExample: "Vosotros iríais si fuera posible.",
          audio: "",
        },
        ellos: {
          conjugation: "irían",
          enExample: "They would go if they had the chance.",
          esExample: "Ellos irían si tuvieran la oportunidad.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "vaya",
          enExample: "I hope I go soon.",
          esExample: "Espero que vaya pronto.",
          audio: "",
        },
        tú: {
          conjugation: "vayas",
          enExample: "I hope you go too.",
          esExample: "Espero que tú vayas también.",
          audio: "",
        },
        él: {
          conjugation: "vaya",
          enExample: "I hope he goes with us.",
          esExample: "Espero que él vaya con nosotros.",
          audio: "",
        },
        nosotros: {
          conjugation: "vayamos",
          enExample: "I hope we go together.",
          esExample: "Espero que vayamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "vayáis",
          enExample: "I hope you all go on time.",
          esExample: "Espero que vosotros vayáis a tiempo.",
          audio: "",
        },
        ellos: {
          conjugation: "vayan",
          enExample: "I hope they go to the party.",
          esExample: "Espero que ellos vayan a la fiesta.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Hablar",
    en: "to speak",
    conjugations: {
      present: {
        yo: {
          conjugation: "hablo",
          enExample: "I speak three languages.",
          esExample: "Hablo tres idiomas.",
          audio: "",
        },
        tú: {
          conjugation: "hablas",
          enExample: "You speak fast.",
          esExample: "Tú hablas rápido.",
          audio: "",
        },
        él: {
          conjugation: "habla",
          enExample: "He speaks English.",
          esExample: "Él habla inglés.",
          audio: "",
        },
        nosotros: {
          conjugation: "hablamos",
          enExample: "We speak Spanish.",
          esExample: "Nosotros hablamos español.",
          audio: "",
        },
        vosotros: {
          conjugation: "habláis",
          enExample: "You all speak loudly.",
          esExample: "Vosotros habláis fuerte.",
          audio: "",
        },
        ellos: {
          conjugation: "hablan",
          enExample: "They speak French.",
          esExample: "Ellos hablan francés.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "hablé",
          enExample: "I spoke to the teacher.",
          esExample: "Yo hablé con el maestro.",
          audio: "",
        },
        tú: {
          conjugation: "hablaste",
          enExample: "You spoke to her.",
          esExample: "Tú hablaste con ella.",
          audio: "",
        },
        él: {
          conjugation: "habló",
          enExample: "He spoke at the meeting.",
          esExample: "Él habló en la reunión.",
          audio: "",
        },
        nosotros: {
          conjugation: "hablamos",
          enExample: "We spoke about it yesterday.",
          esExample: "Nosotros hablamos de ello ayer.",
          audio: "",
        },
        vosotros: {
          conjugation: "hablasteis",
          enExample: "You all spoke on the phone.",
          esExample: "Vosotros hablasteis por teléfono.",
          audio: "",
        },
        ellos: {
          conjugation: "hablaron",
          enExample: "They spoke during class.",
          esExample: "Ellos hablaron durante la clase.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "hablaba",
          enExample: "I was speaking with my friend.",
          esExample: "Yo hablaba con mi amigo.",
          audio: "",
        },
        tú: {
          conjugation: "hablabas",
          enExample: "You were speaking to the teacher.",
          esExample: "Tú hablabas con el maestro.",
          audio: "",
        },
        él: {
          conjugation: "hablaba",
          enExample: "He was speaking very slowly.",
          esExample: "Él hablaba muy despacio.",
          audio: "",
        },
        nosotros: {
          conjugation: "hablábamos",
          enExample: "We were speaking at that time.",
          esExample: "Nosotros hablábamos en ese momento.",
          audio: "",
        },
        vosotros: {
          conjugation: "hablabais",
          enExample: "You all were speaking quietly.",
          esExample: "Vosotros hablabais en voz baja.",
          audio: "",
        },
        ellos: {
          conjugation: "hablaban",
          enExample: "They were speaking about their plans.",
          esExample: "Ellos hablaban sobre sus planes.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "hablaré",
          enExample: "I will speak to her later.",
          esExample: "Hablaré con ella más tarde.",
          audio: "",
        },
        tú: {
          conjugation: "hablarás",
          enExample: "You will speak to your parents.",
          esExample: "Tú hablarás con tus padres.",
          audio: "",
        },
        él: {
          conjugation: "hablará",
          enExample: "He will speak to the audience.",
          esExample: "Él hablará al público.",
          audio: "",
        },
        nosotros: {
          conjugation: "hablaremos",
          enExample: "We will speak tomorrow.",
          esExample: "Nosotros hablaremos mañana.",
          audio: "",
        },
        vosotros: {
          conjugation: "hablaréis",
          enExample: "You all will speak to the teacher.",
          esExample: "Vosotros hablaréis con el maestro.",
          audio: "",
        },
        ellos: {
          conjugation: "hablarán",
          enExample: "They will speak in front of the class.",
          esExample: "Ellos hablarán frente a la clase.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "hablaría",
          enExample: "I would speak louder if I could.",
          esExample: "Hablaría más fuerte si pudiera.",
          audio: "",
        },
        tú: {
          conjugation: "hablarías",
          enExample: "You would speak more if you practiced.",
          esExample: "Tú hablarías más si practicaras.",
          audio: "",
        },
        él: {
          conjugation: "hablaría",
          enExample: "He would speak if he had time.",
          esExample: "Él hablaría si tuviera tiempo.",
          audio: "",
        },
        nosotros: {
          conjugation: "hablaríamos",
          enExample: "We would speak if asked.",
          esExample: "Nosotros hablaríamos si nos pidieran.",
          audio: "",
        },
        vosotros: {
          conjugation: "hablaríais",
          enExample: "You all would speak clearly.",
          esExample: "Vosotros hablaríais claramente.",
          audio: "",
        },
        ellos: {
          conjugation: "hablarían",
          enExample: "They would speak for hours.",
          esExample: "Ellos hablarían durante horas.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "hable",
          enExample: "I hope I speak clearly.",
          esExample: "Espero que hable claramente.",
          audio: "",
        },
        tú: {
          conjugation: "hables",
          enExample: "I hope you speak slowly.",
          esExample: "Espero que tú hables despacio.",
          audio: "",
        },
        él: {
          conjugation: "hable",
          enExample: "I hope he speaks well.",
          esExample: "Espero que él hable bien.",
          audio: "",
        },
        nosotros: {
          conjugation: "hablemos",
          enExample: "I hope we speak soon.",
          esExample: "Espero que hablemos pronto.",
          audio: "",
        },
        vosotros: {
          conjugation: "habléis",
          enExample: "I hope you all speak loudly.",
          esExample: "Espero que vosotros habléis fuerte.",
          audio: "",
        },
        ellos: {
          conjugation: "hablen",
          enExample: "I hope they speak in front of the group.",
          esExample: "Espero que ellos hablen frente al grupo.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Querer",
    en: "to want",
    conjugations: {
      present: {
        yo: {
          conjugation: "quiero",
          enExample: "I want to eat pizza.",
          esExample: "Quiero comer pizza.",
          audio: "",
        },
        tú: {
          conjugation: "quieres",
          enExample: "You want to go home.",
          esExample: "Tú quieres ir a casa.",
          audio: "",
        },
        él: {
          conjugation: "quiere",
          enExample: "He wants to travel.",
          esExample: "Él quiere viajar.",
          audio: "",
        },
        nosotros: {
          conjugation: "queremos",
          enExample: "We want to see the movie.",
          esExample: "Nosotros queremos ver la película.",
          audio: "",
        },
        vosotros: {
          conjugation: "queréis",
          enExample: "You all want to study.",
          esExample: "Vosotros queréis estudiar.",
          audio: "",
        },
        ellos: {
          conjugation: "quieren",
          enExample: "They want to visit Spain.",
          esExample: "Ellos quieren visitar España.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "quise",
          enExample: "I wanted a coffee.",
          esExample: "Yo quise un café.",
          audio: "",
        },
        tú: {
          conjugation: "quisiste",
          enExample: "You wanted to go out.",
          esExample: "Tú quisiste salir.",
          audio: "",
        },
        él: {
          conjugation: "quiso",
          enExample: "He wanted to help.",
          esExample: "Él quiso ayudar.",
          audio: "",
        },
        nosotros: {
          conjugation: "quisimos",
          enExample: "We wanted a break.",
          esExample: "Nosotros quisimos un descanso.",
          audio: "",
        },
        vosotros: {
          conjugation: "quisisteis",
          enExample: "You all wanted a bigger house.",
          esExample: "Vosotros quisisteis una casa más grande.",
          audio: "",
        },
        ellos: {
          conjugation: "quisieron",
          enExample: "They wanted to leave.",
          esExample: "Ellos quisieron irse.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "quería",
          enExample: "I was wanting to leave.",
          esExample: "Yo quería irme.",
          audio: "",
        },
        tú: {
          conjugation: "querías",
          enExample: "You were wanting to stay.",
          esExample: "Tú querías quedarte.",
          audio: "",
        },
        él: {
          conjugation: "quería",
          enExample: "He was wanting to speak.",
          esExample: "Él quería hablar.",
          audio: "",
        },
        nosotros: {
          conjugation: "queríamos",
          enExample: "We were wanting to travel.",
          esExample: "Nosotros queríamos viajar.",
          audio: "",
        },
        vosotros: {
          conjugation: "queríais",
          enExample: "You all were wanting to study.",
          esExample: "Vosotros queríais estudiar.",
          audio: "",
        },
        ellos: {
          conjugation: "querían",
          enExample: "They were wanting to eat.",
          esExample: "Ellos querían comer.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "quereré",
          enExample: "I will want a vacation.",
          esExample: "Quereré unas vacaciones.",
          audio: "",
        },
        tú: {
          conjugation: "querrás",
          enExample: "You will want to go there.",
          esExample: "Tú querrás ir allí.",
          audio: "",
        },
        él: {
          conjugation: "querrá",
          enExample: "He will want to visit Paris.",
          esExample: "Él querrá visitar París.",
          audio: "",
        },
        nosotros: {
          conjugation: "querremos",
          enExample: "We will want more time.",
          esExample: "Nosotros querremos más tiempo.",
          audio: "",
        },
        vosotros: {
          conjugation: "querréis",
          enExample: "You all will want to try this.",
          esExample: "Vosotros querréis probar esto.",
          audio: "",
        },
        ellos: {
          conjugation: "querrán",
          enExample: "They will want to speak.",
          esExample: "Ellos querrán hablar.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "querría",
          enExample: "I would want a coffee.",
          esExample: "Querría un café.",
          audio: "",
        },
        tú: {
          conjugation: "querrías",
          enExample: "You would want to stay here.",
          esExample: "Tú querrías quedarte aquí.",
          audio: "",
        },
        él: {
          conjugation: "querría",
          enExample: "He would want to leave.",
          esExample: "Él querría irse.",
          audio: "",
        },
        nosotros: {
          conjugation: "querríamos",
          enExample: "We would want to travel.",
          esExample: "Nosotros querríamos viajar.",
          audio: "",
        },
        vosotros: {
          conjugation: "querríais",
          enExample: "You all would want to see it.",
          esExample: "Vosotros querríais verlo.",
          audio: "",
        },
        ellos: {
          conjugation: "querrían",
          enExample: "They would want a bigger house.",
          esExample: "Ellos querrían una casa más grande.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "quiera",
          enExample: "I hope I want to go.",
          esExample: "Espero que quiera ir.",
          audio: "",
        },
        tú: {
          conjugation: "quieras",
          enExample: "I hope you want to stay.",
          esExample: "Espero que tú quieras quedarte.",
          audio: "",
        },
        él: {
          conjugation: "quiera",
          enExample: "I hope he wants to help.",
          esExample: "Espero que él quiera ayudar.",
          audio: "",
        },
        nosotros: {
          conjugation: "queramos",
          enExample: "I hope we want to study.",
          esExample: "Espero que queramos estudiar.",
          audio: "",
        },
        vosotros: {
          conjugation: "queráis",
          enExample: "I hope you all want to go there.",
          esExample: "Espero que vosotros queráis ir allí.",
          audio: "",
        },
        ellos: {
          conjugation: "quieran",
          enExample: "I hope they want to come.",
          esExample: "Espero que ellos quieran venir.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Comer",
    en: "to eat",
    conjugations: {
      present: {
        yo: {
          conjugation: "como",
          enExample: "I eat apples every day.",
          esExample: "Como manzanas todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "comes",
          enExample: "You eat lunch at noon.",
          esExample: "Tú comes almuerzo al mediodía.",
          audio: "",
        },
        él: {
          conjugation: "come",
          enExample: "He eats pasta.",
          esExample: "Él come pasta.",
          audio: "",
        },
        nosotros: {
          conjugation: "comemos",
          enExample: "We eat together.",
          esExample: "Nosotros comemos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "coméis",
          enExample: "You all eat at the restaurant.",
          esExample: "Vosotros coméis en el restaurante.",
          audio: "",
        },
        ellos: {
          conjugation: "comen",
          enExample: "They eat pizza.",
          esExample: "Ellos comen pizza.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "comí",
          enExample: "I ate lunch.",
          esExample: "Yo comí almuerzo.",
          audio: "",
        },
        tú: {
          conjugation: "comiste",
          enExample: "You ate dinner.",
          esExample: "Tú comiste la cena.",
          audio: "",
        },
        él: {
          conjugation: "comió",
          enExample: "He ate breakfast.",
          esExample: "Él comió desayuno.",
          audio: "",
        },
        nosotros: {
          conjugation: "comimos",
          enExample: "We ate at noon.",
          esExample: "Nosotros comimos al mediodía.",
          audio: "",
        },
        vosotros: {
          conjugation: "comisteis",
          enExample: "You all ate pizza.",
          esExample: "Vosotros comisteis pizza.",
          audio: "",
        },
        ellos: {
          conjugation: "comieron",
          enExample: "They ate together.",
          esExample: "Ellos comieron juntos.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "comía",
          enExample: "I was eating pasta.",
          esExample: "Yo comía pasta.",
          audio: "",
        },
        tú: {
          conjugation: "comías",
          enExample: "You were eating pizza.",
          esExample: "Tú comías pizza.",
          audio: "",
        },
        él: {
          conjugation: "comía",
          enExample: "He was eating breakfast.",
          esExample: "Él comía desayuno.",
          audio: "",
        },
        nosotros: {
          conjugation: "comíamos",
          enExample: "We were eating together.",
          esExample: "Nosotros comíamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "comíais",
          enExample: "You all were eating at the table.",
          esExample: "Vosotros comíais en la mesa.",
          audio: "",
        },
        ellos: {
          conjugation: "comían",
          enExample: "They were eating pizza.",
          esExample: "Ellos comían pizza.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "comeré",
          enExample: "I will eat pizza later.",
          esExample: "Comeré pizza más tarde.",
          audio: "",
        },
        tú: {
          conjugation: "comerás",
          enExample: "You will eat breakfast tomorrow.",
          esExample: "Tú comerás desayuno mañana.",
          audio: "",
        },
        él: {
          conjugation: "comerá",
          enExample: "He will eat at the restaurant.",
          esExample: "Él comerá en el restaurante.",
          audio: "",
        },
        nosotros: {
          conjugation: "comeremos",
          enExample: "We will eat lunch later.",
          esExample: "Nosotros comeremos almuerzo más tarde.",
          audio: "",
        },
        vosotros: {
          conjugation: "comeréis",
          enExample: "You all will eat soon.",
          esExample: "Vosotros comeréis pronto.",
          audio: "",
        },
        ellos: {
          conjugation: "comerán",
          enExample: "They will eat together.",
          esExample: "Ellos comerán juntos.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "comería",
          enExample: "I would eat more if I were hungry.",
          esExample: "Comería más si tuviera hambre.",
          audio: "",
        },
        tú: {
          conjugation: "comerías",
          enExample: "You would eat if you could.",
          esExample: "Tú comerías si pudieras.",
          audio: "",
        },
        él: {
          conjugation: "comería",
          enExample: "He would eat if he were invited.",
          esExample: "Él comería si lo invitaran.",
          audio: "",
        },
        nosotros: {
          conjugation: "comeríamos",
          enExample: "We would eat if we had time.",
          esExample: "Nosotros comeríamos si tuviéramos tiempo.",
          audio: "",
        },
        vosotros: {
          conjugation: "comeríais",
          enExample: "You all would eat if it were possible.",
          esExample: "Vosotros comeríais si fuera posible.",
          audio: "",
        },
        ellos: {
          conjugation: "comerían",
          enExample: "They would eat pizza.",
          esExample: "Ellos comerían pizza.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "coma",
          enExample: "I hope I eat well.",
          esExample: "Espero que coma bien.",
          audio: "",
        },
        tú: {
          conjugation: "comas",
          enExample: "I hope you eat healthy.",
          esExample: "Espero que comas saludable.",
          audio: "",
        },
        él: {
          conjugation: "coma",
          enExample: "I hope he eats soon.",
          esExample: "Espero que él coma pronto.",
          audio: "",
        },
        nosotros: {
          conjugation: "comamos",
          enExample: "I hope we eat together.",
          esExample: "Espero que comamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "comáis",
          enExample: "I hope you all eat soon.",
          esExample: "Espero que vosotros comáis pronto.",
          audio: "",
        },
        ellos: {
          conjugation: "coman",
          enExample: "I hope they eat healthily.",
          esExample: "Espero que ellos coman saludablemente.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Caminar",
    en: "to walk",
    conjugations: {
      present: {
        yo: {
          conjugation: "camino",
          enExample: "I walk to work every day.",
          esExample: "Camino al trabajo todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "caminas",
          enExample: "You walk to the park.",
          esExample: "Tú caminas al parque.",
          audio: "",
        },
        él: {
          conjugation: "camina",
          enExample: "He walks in the morning.",
          esExample: "Él camina por la mañana.",
          audio: "",
        },
        nosotros: {
          conjugation: "caminamos",
          enExample: "We walk to the store.",
          esExample: "Nosotros caminamos a la tienda.",
          audio: "",
        },
        vosotros: {
          conjugation: "camináis",
          enExample: "You all walk together.",
          esExample: "Vosotros camináis juntos.",
          audio: "",
        },
        ellos: {
          conjugation: "caminan",
          enExample: "They walk every day.",
          esExample: "Ellos caminan todos los días.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "caminé",
          enExample: "I walked to the shop.",
          esExample: "Yo caminé a la tienda.",
          audio: "",
        },
        tú: {
          conjugation: "caminaste",
          enExample: "You walked for an hour.",
          esExample: "Tú caminaste por una hora.",
          audio: "",
        },
        él: {
          conjugation: "caminó",
          enExample: "He walked alone.",
          esExample: "Él caminó solo.",
          audio: "",
        },
        nosotros: {
          conjugation: "caminamos",
          enExample: "We walked all day.",
          esExample: "Nosotros caminamos todo el día.",
          audio: "",
        },
        vosotros: {
          conjugation: "caminasteis",
          enExample: "You all walked to the beach.",
          esExample: "Vosotros caminasteis a la playa.",
          audio: "",
        },
        ellos: {
          conjugation: "caminaron",
          enExample: "They walked around the city.",
          esExample: "Ellos caminaron por la ciudad.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "caminaba",
          enExample: "I was walking when I saw you.",
          esExample: "Yo caminaba cuando te vi.",
          audio: "",
        },
        tú: {
          conjugation: "caminabas",
          enExample: "You were walking with a friend.",
          esExample: "Tú caminabas con un amigo.",
          audio: "",
        },
        él: {
          conjugation: "caminaba",
          enExample: "He was walking to work.",
          esExample: "Él caminaba al trabajo.",
          audio: "",
        },
        nosotros: {
          conjugation: "caminábamos",
          enExample: "We were walking in the park.",
          esExample: "Nosotros caminábamos en el parque.",
          audio: "",
        },
        vosotros: {
          conjugation: "caminabais",
          enExample: "You all were walking when it started to rain.",
          esExample: "Vosotros caminabais cuando comenzó a llover.",
          audio: "",
        },
        ellos: {
          conjugation: "caminaban",
          enExample: "They were walking down the street.",
          esExample: "Ellos caminaban por la calle.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "caminaré",
          enExample: "I will walk tomorrow.",
          esExample: "Caminaré mañana.",
          audio: "",
        },
        tú: {
          conjugation: "caminarás",
          enExample: "You will walk to the store.",
          esExample: "Tú caminarás a la tienda.",
          audio: "",
        },
        él: {
          conjugation: "caminará",
          enExample: "He will walk to the park.",
          esExample: "Él caminará al parque.",
          audio: "",
        },
        nosotros: {
          conjugation: "caminaremos",
          enExample: "We will walk together.",
          esExample: "Nosotros caminaremos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "caminaréis",
          enExample: "You all will walk to the office.",
          esExample: "Vosotros caminaréis a la oficina.",
          audio: "",
        },
        ellos: {
          conjugation: "caminarán",
          enExample: "They will walk every morning.",
          esExample: "Ellos caminarán todas las mañanas.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "caminaría",
          enExample: "I would walk if it were sunny.",
          esExample: "Caminaría si estuviera soleado.",
          audio: "",
        },
        tú: {
          conjugation: "caminarías",
          enExample: "You would walk if you had time.",
          esExample: "Tú caminarías si tuvieras tiempo.",
          audio: "",
        },
        él: {
          conjugation: "caminaría",
          enExample: "He would walk if he were invited.",
          esExample: "Él caminaría si lo invitaran.",
          audio: "",
        },
        nosotros: {
          conjugation: "caminaríamos",
          enExample: "We would walk if it were warm.",
          esExample: "Nosotros caminaríamos si estuviera cálido.",
          audio: "",
        },
        vosotros: {
          conjugation: "caminaríais",
          enExample: "You all would walk if you could.",
          esExample: "Vosotros caminaríais si pudierais.",
          audio: "",
        },
        ellos: {
          conjugation: "caminarían",
          enExample: "They would walk if they had a chance.",
          esExample: "Ellos caminarían si tuvieran la oportunidad.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "camine",
          enExample: "I hope I walk every day.",
          esExample: "Espero que camine todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "camines",
          enExample: "I hope you walk faster.",
          esExample: "Espero que tú camines más rápido.",
          audio: "",
        },
        él: {
          conjugation: "camine",
          enExample: "I hope he walks well.",
          esExample: "Espero que él camine bien.",
          audio: "",
        },
        nosotros: {
          conjugation: "caminemos",
          enExample: "I hope we walk together.",
          esExample: "Espero que caminemos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "caminéis",
          enExample: "I hope you all walk today.",
          esExample: "Espero que vosotros caminéis hoy.",
          audio: "",
        },
        ellos: {
          conjugation: "caminen",
          enExample: "I hope they walk around the city.",
          esExample: "Espero que ellos caminen por la ciudad.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Correr",
    en: "to run",
    conjugations: {
      present: {
        yo: {
          conjugation: "corro",
          enExample: "I run every morning.",
          esExample: "Corro cada mañana.",
          audio: "",
        },
        tú: {
          conjugation: "corres",
          enExample: "You run fast.",
          esExample: "Tú corres rápido.",
          audio: "",
        },
        él: {
          conjugation: "corre",
          enExample: "He runs every day.",
          esExample: "Él corre todos los días.",
          audio: "",
        },
        nosotros: {
          conjugation: "corremos",
          enExample: "We run together.",
          esExample: "Nosotros corremos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "corréis",
          enExample: "You all run at the park.",
          esExample: "Vosotros corréis en el parque.",
          audio: "",
        },
        ellos: {
          conjugation: "corren",
          enExample: "They run at night.",
          esExample: "Ellos corren por la noche.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "corrí",
          enExample: "I ran five kilometers yesterday.",
          esExample: "Corrí cinco kilómetros ayer.",
          audio: "",
        },
        tú: {
          conjugation: "corriste",
          enExample: "You ran in the morning.",
          esExample: "Tú corriste por la mañana.",
          audio: "",
        },
        él: {
          conjugation: "corrió",
          enExample: "He ran a marathon.",
          esExample: "Él corrió un maratón.",
          audio: "",
        },
        nosotros: {
          conjugation: "corrimos",
          enExample: "We ran together.",
          esExample: "Nosotros corrimos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "corristeis",
          enExample: "You all ran last week.",
          esExample: "Vosotros corristeis la semana pasada.",
          audio: "",
        },
        ellos: {
          conjugation: "corrieron",
          enExample: "They ran in the park.",
          esExample: "Ellos corrieron en el parque.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "corría",
          enExample: "I was running when I hurt my foot.",
          esExample: "Yo corría cuando me lastimé el pie.",
          audio: "",
        },
        tú: {
          conjugation: "corrías",
          enExample: "You were running last night.",
          esExample: "Tú corrías anoche.",
          audio: "",
        },
        él: {
          conjugation: "corría",
          enExample: "He was running every day.",
          esExample: "Él corría todos los días.",
          audio: "",
        },
        nosotros: {
          conjugation: "corríamos",
          enExample: "We were running in the park.",
          esExample: "Nosotros corríamos en el parque.",
          audio: "",
        },
        vosotros: {
          conjugation: "corríais",
          enExample: "You all were running last year.",
          esExample: "Vosotros corríais el año pasado.",
          audio: "",
        },
        ellos: {
          conjugation: "corrían",
          enExample: "They were running in the rain.",
          esExample: "Ellos corrían bajo la lluvia.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "correré",
          enExample: "I will run tomorrow.",
          esExample: "Correré mañana.",
          audio: "",
        },
        tú: {
          conjugation: "correrás",
          enExample: "You will run next week.",
          esExample: "Tú correrás la próxima semana.",
          audio: "",
        },
        él: {
          conjugation: "correrá",
          enExample: "He will run every morning.",
          esExample: "Él correrá todas las mañanas.",
          audio: "",
        },
        nosotros: {
          conjugation: "correremos",
          enExample: "We will run at the park.",
          esExample: "Nosotros correremos en el parque.",
          audio: "",
        },
        vosotros: {
          conjugation: "correréis",
          enExample: "You all will run this afternoon.",
          esExample: "Vosotros correréis esta tarde.",
          audio: "",
        },
        ellos: {
          conjugation: "correrán",
          enExample: "They will run tomorrow morning.",
          esExample: "Ellos correrán mañana por la mañana.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "correría",
          enExample: "I would run if I had time.",
          esExample: "Correría si tuviera tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "correrías",
          enExample: "You would run faster if you trained.",
          esExample: "Tú correrías más rápido si entrenaras.",
          audio: "",
        },
        él: {
          conjugation: "correría",
          enExample: "He would run if he weren't tired.",
          esExample: "Él correría si no estuviera cansado.",
          audio: "",
        },
        nosotros: {
          conjugation: "correríamos",
          enExample: "We would run if we had a chance.",
          esExample: "Nosotros correríamos si tuviéramos la oportunidad.",
          audio: "",
        },
        vosotros: {
          conjugation: "correríais",
          enExample: "You all would run if you tried.",
          esExample: "Vosotros correríais si intentáis.",
          audio: "",
        },
        ellos: {
          conjugation: "correrían",
          enExample: "They would run if it were sunny.",
          esExample: "Ellos correrían si estuviera soleado.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "corra",
          enExample: "I hope I run faster.",
          esExample: "Espero que corra más rápido.",
          audio: "",
        },
        tú: {
          conjugation: "corras",
          enExample: "I hope you run soon.",
          esExample: "Espero que tú corras pronto.",
          audio: "",
        },
        él: {
          conjugation: "corra",
          enExample: "I hope he runs well.",
          esExample: "Espero que él corra bien.",
          audio: "",
        },
        nosotros: {
          conjugation: "corramos",
          enExample: "I hope we run together.",
          esExample: "Espero que corramos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "corráis",
          enExample: "I hope you all run faster.",
          esExample: "Espero que vosotros corráis más rápido.",
          audio: "",
        },
        ellos: {
          conjugation: "corran",
          enExample: "I hope they run tomorrow.",
          esExample: "Espero que ellos corran mañana.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Aprender",
    en: "to learn",
    conjugations: {
      present: {
        yo: {
          conjugation: "aprendo",
          enExample: "I learn Spanish every day.",
          esExample: "Aprendo español todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "aprendes",
          enExample: "You learn quickly.",
          esExample: "Tú aprendes rápidamente.",
          audio: "",
        },
        él: {
          conjugation: "aprende",
          enExample: "He learns new things.",
          esExample: "Él aprende cosas nuevas.",
          audio: "",
        },
        nosotros: {
          conjugation: "aprendemos",
          enExample: "We learn together.",
          esExample: "Nosotros aprendemos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "aprendéis",
          enExample: "You all learn fast.",
          esExample: "Vosotros aprendéis rápido.",
          audio: "",
        },
        ellos: {
          conjugation: "aprenden",
          enExample: "They learn a lot.",
          esExample: "Ellos aprenden mucho.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "aprendí",
          enExample: "I learned a lot yesterday.",
          esExample: "Aprendí mucho ayer.",
          audio: "",
        },
        tú: {
          conjugation: "aprendiste",
          enExample: "You learned the lesson.",
          esExample: "Tú aprendiste la lección.",
          audio: "",
        },
        él: {
          conjugation: "aprendió",
          enExample: "He learned the new concept.",
          esExample: "Él aprendió el nuevo concepto.",
          audio: "",
        },
        nosotros: {
          conjugation: "aprendimos",
          enExample: "We learned something new.",
          esExample: "Nosotros aprendimos algo nuevo.",
          audio: "",
        },
        vosotros: {
          conjugation: "aprendisteis",
          enExample: "You all learned together.",
          esExample: "Vosotros aprendisteis juntos.",
          audio: "",
        },
        ellos: {
          conjugation: "aprendieron",
          enExample: "They learned the language.",
          esExample: "Ellos aprendieron el idioma.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "aprendía",
          enExample: "I was learning when you called.",
          esExample: "Yo aprendía cuando me llamaste.",
          audio: "",
        },
        tú: {
          conjugation: "aprendías",
          enExample: "You were learning at school.",
          esExample: "Tú aprendías en la escuela.",
          audio: "",
        },
        él: {
          conjugation: "aprendía",
          enExample: "He was learning every day.",
          esExample: "Él aprendía todos los días.",
          audio: "",
        },
        nosotros: {
          conjugation: "aprendíamos",
          enExample: "We were learning new things.",
          esExample: "Nosotros aprendíamos cosas nuevas.",
          audio: "",
        },
        vosotros: {
          conjugation: "aprendíais",
          enExample: "You all were learning together.",
          esExample: "Vosotros aprendíais juntos.",
          audio: "",
        },
        ellos: {
          conjugation: "aprendían",
          enExample: "They were learning the rules.",
          esExample: "Ellos aprendían las reglas.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "aprenderé",
          enExample: "I will learn more tomorrow.",
          esExample: "Aprenderé más mañana.",
          audio: "",
        },
        tú: {
          conjugation: "aprenderás",
          enExample: "You will learn Spanish.",
          esExample: "Tú aprenderás español.",
          audio: "",
        },
        él: {
          conjugation: "aprenderá",
          enExample: "He will learn fast.",
          esExample: "Él aprenderá rápido.",
          audio: "",
        },
        nosotros: {
          conjugation: "aprenderemos",
          enExample: "We will learn something new.",
          esExample: "Nosotros aprenderemos algo nuevo.",
          audio: "",
        },
        vosotros: {
          conjugation: "aprenderéis",
          enExample: "You all will learn at school.",
          esExample: "Vosotros aprenderéis en la escuela.",
          audio: "",
        },
        ellos: {
          conjugation: "aprenderán",
          enExample: "They will learn a lot.",
          esExample: "Ellos aprenderán mucho.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "aprendería",
          enExample: "I would learn if I had time.",
          esExample: "Aprendería si tuviera tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "aprenderías",
          enExample: "You would learn more if you practiced.",
          esExample: "Tú aprenderías más si practicaras.",
          audio: "",
        },
        él: {
          conjugation: "aprendería",
          enExample: "He would learn if he could.",
          esExample: "Él aprendería si pudiera.",
          audio: "",
        },
        nosotros: {
          conjugation: "aprenderíamos",
          enExample: "We would learn together.",
          esExample: "Nosotros aprenderíamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "aprenderíais",
          enExample: "You all would learn if you studied.",
          esExample: "Vosotros aprenderíais si estudiarais.",
          audio: "",
        },
        ellos: {
          conjugation: "aprenderían",
          enExample: "They would learn if they had time.",
          esExample: "Ellos aprenderían si tuvieran tiempo.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "aprenda",
          enExample: "I hope I learn quickly.",
          esExample: "Espero que aprenda rápido.",
          audio: "",
        },
        tú: {
          conjugation: "aprendas",
          enExample: "I hope you learn faster.",
          esExample: "Espero que tú aprendas más rápido.",
          audio: "",
        },
        él: {
          conjugation: "aprenda",
          enExample: "I hope he learns well.",
          esExample: "Espero que él aprenda bien.",
          audio: "",
        },
        nosotros: {
          conjugation: "aprendamos",
          enExample: "I hope we learn together.",
          esExample: "Espero que aprendamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "aprendáis",
          enExample: "I hope you all learn quickly.",
          esExample: "Espero que vosotros aprendáis rápido.",
          audio: "",
        },
        ellos: {
          conjugation: "aprendan",
          enExample: "I hope they learn new things.",
          esExample: "Espero que ellos aprendan cosas nuevas.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Vivir",
    en: "to live",
    conjugations: {
      present: {
        yo: {
          conjugation: "vivo",
          enExample: "I live in Spain.",
          esExample: "Vivo en España.",
          audio: "",
        },
        tú: {
          conjugation: "vives",
          enExample: "You live in a house.",
          esExample: "Tú vives en una casa.",
          audio: "",
        },
        él: {
          conjugation: "vive",
          enExample: "He lives in the city.",
          esExample: "Él vive en la ciudad.",
          audio: "",
        },
        nosotros: {
          conjugation: "vivimos",
          enExample: "We live near the beach.",
          esExample: "Nosotros vivimos cerca de la playa.",
          audio: "",
        },
        vosotros: {
          conjugation: "vivís",
          enExample: "You all live in the mountains.",
          esExample: "Vosotros vivís en las montañas.",
          audio: "",
        },
        ellos: {
          conjugation: "viven",
          enExample: "They live in a big house.",
          esExample: "Ellos viven en una casa grande.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "viví",
          enExample: "I lived in the city.",
          esExample: "Yo viví en la ciudad.",
          audio: "",
        },
        tú: {
          conjugation: "viviste",
          enExample: "You lived in London.",
          esExample: "Tú viviste en Londres.",
          audio: "",
        },
        él: {
          conjugation: "vivió",
          enExample: "He lived in Paris.",
          esExample: "Él vivió en París.",
          audio: "",
        },
        nosotros: {
          conjugation: "vivimos",
          enExample: "We lived in the village.",
          esExample: "Nosotros vivimos en el pueblo.",
          audio: "",
        },
        vosotros: {
          conjugation: "vivisteis",
          enExample: "You all lived together.",
          esExample: "Vosotros vivisteis juntos.",
          audio: "",
        },
        ellos: {
          conjugation: "vivieron",
          enExample: "They lived in that house.",
          esExample: "Ellos vivieron en esa casa.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "vivía",
          enExample: "I was living with my parents.",
          esExample: "Yo vivía con mis padres.",
          audio: "",
        },
        tú: {
          conjugation: "vivías",
          enExample: "You were living in Madrid.",
          esExample: "Tú vivías en Madrid.",
          audio: "",
        },
        él: {
          conjugation: "vivía",
          enExample: "He was living in that apartment.",
          esExample: "Él vivía en ese apartamento.",
          audio: "",
        },
        nosotros: {
          conjugation: "vivíamos",
          enExample: "We were living in a small town.",
          esExample: "Nosotros vivíamos en un pueblo pequeño.",
          audio: "",
        },
        vosotros: {
          conjugation: "vivíais",
          enExample: "You all were living in a house.",
          esExample: "Vosotros vivíais en una casa.",
          audio: "",
        },
        ellos: {
          conjugation: "vivían",
          enExample: "They were living there.",
          esExample: "Ellos vivían allí.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "viviré",
          enExample: "I will live in a house.",
          esExample: "Viviré en una casa.",
          audio: "",
        },
        tú: {
          conjugation: "vivirás",
          enExample: "You will live in a big city.",
          esExample: "Tú vivirás en una ciudad grande.",
          audio: "",
        },
        él: {
          conjugation: "vivirá",
          enExample: "He will live abroad.",
          esExample: "Él vivirá en el extranjero.",
          audio: "",
        },
        nosotros: {
          conjugation: "viviremos",
          enExample: "We will live near the sea.",
          esExample: "Nosotros viviremos cerca del mar.",
          audio: "",
        },
        vosotros: {
          conjugation: "viviréis",
          enExample: "You all will live in this neighborhood.",
          esExample: "Vosotros viviréis en este barrio.",
          audio: "",
        },
        ellos: {
          conjugation: "vivirán",
          enExample: "They will live in another country.",
          esExample: "Ellos vivirán en otro país.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "viviría",
          enExample: "I would live in the countryside.",
          esExample: "Viviría en el campo.",
          audio: "",
        },
        tú: {
          conjugation: "vivirías",
          enExample: "You would live near the beach.",
          esExample: "Tú vivirías cerca de la playa.",
          audio: "",
        },
        él: {
          conjugation: "viviría",
          enExample: "He would live in a bigger house.",
          esExample: "Él viviría en una casa más grande.",
          audio: "",
        },
        nosotros: {
          conjugation: "viviríamos",
          enExample: "We would live in Spain.",
          esExample: "Nosotros viviríamos en España.",
          audio: "",
        },
        vosotros: {
          conjugation: "viviríais",
          enExample: "You all would live together.",
          esExample: "Vosotros viviríais juntos.",
          audio: "",
        },
        ellos: {
          conjugation: "vivirían",
          enExample: "They would live here.",
          esExample: "Ellos vivirían aquí.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "viva",
          enExample: "I hope I live happily.",
          esExample: "Espero que viva feliz.",
          audio: "",
        },
        tú: {
          conjugation: "vivas",
          enExample: "I hope you live well.",
          esExample: "Espero que vivas bien.",
          audio: "",
        },
        él: {
          conjugation: "viva",
          enExample: "I hope he lives in peace.",
          esExample: "Espero que él viva en paz.",
          audio: "",
        },
        nosotros: {
          conjugation: "vivamos",
          enExample: "I hope we live together.",
          esExample: "Espero que vivamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "viváis",
          enExample: "I hope you all live close by.",
          esExample: "Espero que vosotros viváis cerca.",
          audio: "",
        },
        ellos: {
          conjugation: "vivan",
          enExample: "I hope they live happily.",
          esExample: "Espero que ellos vivan felices.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Llegar",
    en: "to arrive",
    conjugations: {
      present: {
        yo: {
          conjugation: "llego",
          enExample: "I arrive at 8 am every day.",
          esExample: "Llego a las 8 am todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "llegas",
          enExample: "You arrive at noon.",
          esExample: "Tú llegas al mediodía.",
          audio: "",
        },
        él: {
          conjugation: "llega",
          enExample: "He arrives late.",
          esExample: "Él llega tarde.",
          audio: "",
        },
        nosotros: {
          conjugation: "llegamos",
          enExample: "We arrive together.",
          esExample: "Nosotros llegamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "llegáis",
          enExample: "You all arrive early.",
          esExample: "Vosotros llegáis temprano.",
          audio: "",
        },
        ellos: {
          conjugation: "llegan",
          enExample: "They arrive every week.",
          esExample: "Ellos llegan todas las semanas.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "llegué",
          enExample: "I arrived late yesterday.",
          esExample: "Yo llegué tarde ayer.",
          audio: "",
        },
        tú: {
          conjugation: "llegaste",
          enExample: "You arrived this morning.",
          esExample: "Tú llegaste esta mañana.",
          audio: "",
        },
        él: {
          conjugation: "llegó",
          enExample: "He arrived at noon.",
          esExample: "Él llegó al mediodía.",
          audio: "",
        },
        nosotros: {
          conjugation: "llegamos",
          enExample: "We arrived early.",
          esExample: "Nosotros llegamos temprano.",
          audio: "",
        },
        vosotros: {
          conjugation: "llegasteis",
          enExample: "You all arrived at the airport.",
          esExample: "Vosotros llegasteis al aeropuerto.",
          audio: "",
        },
        ellos: {
          conjugation: "llegaron",
          enExample: "They arrived late.",
          esExample: "Ellos llegaron tarde.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "llegaba",
          enExample: "I was arriving when you called.",
          esExample: "Yo llegaba cuando me llamaste.",
          audio: "",
        },
        tú: {
          conjugation: "llegabas",
          enExample: "You were arriving at the station.",
          esExample: "Tú llegabas a la estación.",
          audio: "",
        },
        él: {
          conjugation: "llegaba",
          enExample: "He was arriving at the office.",
          esExample: "Él llegaba a la oficina.",
          audio: "",
        },
        nosotros: {
          conjugation: "llegábamos",
          enExample: "We were arriving together.",
          esExample: "Nosotros llegábamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "llegabais",
          enExample: "You all were arriving when it started to rain.",
          esExample: "Vosotros llegabais cuando comenzó a llover.",
          audio: "",
        },
        ellos: {
          conjugation: "llegaban",
          enExample: "They were arriving when I left.",
          esExample: "Ellos llegaban cuando me fui.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "llegaré",
          enExample: "I will arrive at 9 am.",
          esExample: "Llegaré a las 9 am.",
          audio: "",
        },
        tú: {
          conjugation: "llegarás",
          enExample: "You will arrive soon.",
          esExample: "Tú llegarás pronto.",
          audio: "",
        },
        él: {
          conjugation: "llegará",
          enExample: "He will arrive tomorrow.",
          esExample: "Él llegará mañana.",
          audio: "",
        },
        nosotros: {
          conjugation: "llegaremos",
          enExample: "We will arrive at 10 am.",
          esExample: "Nosotros llegaremos a las 10 am.",
          audio: "",
        },
        vosotros: {
          conjugation: "llegaréis",
          enExample: "You all will arrive at 8 pm.",
          esExample: "Vosotros llegaréis a las 8 pm.",
          audio: "",
        },
        ellos: {
          conjugation: "llegarán",
          enExample: "They will arrive later.",
          esExample: "Ellos llegarán más tarde.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "llegaría",
          enExample: "I would arrive if I had time.",
          esExample: "Llegaría si tuviera tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "llegarías",
          enExample: "You would arrive earlier if you left now.",
          esExample: "Tú llegarías más temprano si salieras ahora.",
          audio: "",
        },
        él: {
          conjugation: "llegaría",
          enExample: "He would arrive at 7 pm.",
          esExample: "Él llegaría a las 7 pm.",
          audio: "",
        },
        nosotros: {
          conjugation: "llegaríamos",
          enExample: "We would arrive by train.",
          esExample: "Nosotros llegaríamos en tren.",
          audio: "",
        },
        vosotros: {
          conjugation: "llegaríais",
          enExample: "You all would arrive if you tried.",
          esExample: "Vosotros llegaríais si intentáis.",
          audio: "",
        },
        ellos: {
          conjugation: "llegarían",
          enExample: "They would arrive earlier if they could.",
          esExample: "Ellos llegarían más temprano si pudieran.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "llegue",
          enExample: "I hope I arrive on time.",
          esExample: "Espero que llegue a tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "llegues",
          enExample: "I hope you arrive soon.",
          esExample: "Espero que llegues pronto.",
          audio: "",
        },
        él: {
          conjugation: "llegue",
          enExample: "I hope he arrives on time.",
          esExample: "Espero que él llegue a tiempo.",
          audio: "",
        },
        nosotros: {
          conjugation: "lleguemos",
          enExample: "I hope we arrive together.",
          esExample: "Espero que lleguemos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "lleguéis",
          enExample: "I hope you all arrive safely.",
          esExample: "Espero que vosotros lleguéis seguros.",
          audio: "",
        },
        ellos: {
          conjugation: "lleguen",
          enExample: "I hope they arrive early.",
          esExample: "Espero que ellos lleguen temprano.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Jugar",
    en: "to play",
    conjugations: {
      present: {
        yo: {
          conjugation: "juego",
          enExample: "I play soccer every weekend.",
          esExample: "Juego al fútbol cada fin de semana.",
          audio: "",
        },
        tú: {
          conjugation: "juegas",
          enExample: "You play tennis.",
          esExample: "Tú juegas al tenis.",
          audio: "",
        },
        él: {
          conjugation: "juega",
          enExample: "He plays basketball.",
          esExample: "Él juega al baloncesto.",
          audio: "",
        },
        nosotros: {
          conjugation: "jugamos",
          enExample: "We play together.",
          esExample: "Nosotros jugamos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "jugáis",
          enExample: "You all play video games.",
          esExample: "Vosotros jugáis a los videojuegos.",
          audio: "",
        },
        ellos: {
          conjugation: "juegan",
          enExample: "They play the guitar.",
          esExample: "Ellos juegan a la guitarra.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "jugué",
          enExample: "I played yesterday.",
          esExample: "Yo jugué ayer.",
          audio: "",
        },
        tú: {
          conjugation: "jugaste",
          enExample: "You played a match.",
          esExample: "Tú jugaste un partido.",
          audio: "",
        },
        él: {
          conjugation: "jugó",
          enExample: "He played the game.",
          esExample: "Él jugó al juego.",
          audio: "",
        },
        nosotros: {
          conjugation: "jugamos",
          enExample: "We played yesterday.",
          esExample: "Nosotros jugamos ayer.",
          audio: "",
        },
        vosotros: {
          conjugation: "jugasteis",
          enExample: "You all played a game.",
          esExample: "Vosotros jugasteis a un juego.",
          audio: "",
        },
        ellos: {
          conjugation: "jugaron",
          enExample: "They played football.",
          esExample: "Ellos jugaron al fútbol.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "jugaba",
          enExample: "I was playing with my friend.",
          esExample: "Yo jugaba con mi amigo.",
          audio: "",
        },
        tú: {
          conjugation: "jugabas",
          enExample: "You were playing when I arrived.",
          esExample: "Tú jugabas cuando llegué.",
          audio: "",
        },
        él: {
          conjugation: "jugaba",
          enExample: "He was playing chess.",
          esExample: "Él jugaba ajedrez.",
          audio: "",
        },
        nosotros: {
          conjugation: "jugábamos",
          enExample: "We were playing at the park.",
          esExample: "Nosotros jugábamos en el parque.",
          audio: "",
        },
        vosotros: {
          conjugation: "jugabais",
          enExample: "You all were playing cards.",
          esExample: "Vosotros jugabais a las cartas.",
          audio: "",
        },
        ellos: {
          conjugation: "jugaban",
          enExample: "They were playing all day.",
          esExample: "Ellos jugaban todo el día.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "jugaré",
          enExample: "I will play tomorrow.",
          esExample: "Jugaré mañana.",
          audio: "",
        },
        tú: {
          conjugation: "jugarás",
          enExample: "You will play next weekend.",
          esExample: "Tú jugarás el próximo fin de semana.",
          audio: "",
        },
        él: {
          conjugation: "jugará",
          enExample: "He will play later.",
          esExample: "Él jugará más tarde.",
          audio: "",
        },
        nosotros: {
          conjugation: "jugaremos",
          enExample: "We will play together next week.",
          esExample: "Nosotros jugaremos juntos la próxima semana.",
          audio: "",
        },
        vosotros: {
          conjugation: "jugaréis",
          enExample: "You all will play soon.",
          esExample: "Vosotros jugaréis pronto.",
          audio: "",
        },
        ellos: {
          conjugation: "jugarán",
          enExample: "They will play tomorrow.",
          esExample: "Ellos jugarán mañana.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "jugaría",
          enExample: "I would play if I had time.",
          esExample: "Jugaría si tuviera tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "jugarías",
          enExample: "You would play if it were sunny.",
          esExample: "Tú jugarías si estuviera soleado.",
          audio: "",
        },
        él: {
          conjugation: "jugaría",
          enExample: "He would play if he could.",
          esExample: "Él jugaría si pudiera.",
          audio: "",
        },
        nosotros: {
          conjugation: "jugaríamos",
          enExample: "We would play if we had a ball.",
          esExample: "Nosotros jugaríamos si tuviéramos una pelota.",
          audio: "",
        },
        vosotros: {
          conjugation: "jugaríais",
          enExample: "You all would play if you had the opportunity.",
          esExample: "Vosotros jugaríais si tuvierais la oportunidad.",
          audio: "",
        },
        ellos: {
          conjugation: "jugarían",
          enExample: "They would play if they were invited.",
          esExample: "Ellos jugarían si los invitaran.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "juegue",
          enExample: "I hope I play well.",
          esExample: "Espero que juegue bien.",
          audio: "",
        },
        tú: {
          conjugation: "juegues",
          enExample: "I hope you play tomorrow.",
          esExample: "Espero que tú juegues mañana.",
          audio: "",
        },
        él: {
          conjugation: "juegue",
          enExample: "I hope he plays well.",
          esExample: "Espero que él juegue bien.",
          audio: "",
        },
        nosotros: {
          conjugation: "juguemos",
          enExample: "I hope we play together.",
          esExample: "Espero que juguemos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "juguéis",
          enExample: "I hope you all play well.",
          esExample: "Espero que vosotros juguéis bien.",
          audio: "",
        },
        ellos: {
          conjugation: "jueguen",
          enExample: "I hope they play in the tournament.",
          esExample: "Espero que ellos jueguen en el torneo.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Beber",
    en: "to drink",
    conjugations: {
      present: {
        yo: {
          conjugation: "bebo",
          enExample: "I drink coffee every morning.",
          esExample: "Bebo café cada mañana.",
          audio: "",
        },
        tú: {
          conjugation: "bebes",
          enExample: "You drink tea.",
          esExample: "Tú bebes té.",
          audio: "",
        },
        él: {
          conjugation: "bebe",
          enExample: "He drinks juice.",
          esExample: "Él bebe jugo.",
          audio: "",
        },
        nosotros: {
          conjugation: "bebemos",
          enExample: "We drink water.",
          esExample: "Nosotros bebemos agua.",
          audio: "",
        },
        vosotros: {
          conjugation: "bebéis",
          enExample: "You all drink soda.",
          esExample: "Vosotros bebéis refrescos.",
          audio: "",
        },
        ellos: {
          conjugation: "beben",
          enExample: "They drink wine.",
          esExample: "Ellos beben vino.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "bebí",
          enExample: "I drank a glass of water.",
          esExample: "Yo bebí un vaso de agua.",
          audio: "",
        },
        tú: {
          conjugation: "bebiste",
          enExample: "You drank milk.",
          esExample: "Tú bebiste leche.",
          audio: "",
        },
        él: {
          conjugation: "bebió",
          enExample: "He drank coffee.",
          esExample: "Él bebió café.",
          audio: "",
        },
        nosotros: {
          conjugation: "bebimos",
          enExample: "We drank wine.",
          esExample: "Nosotros bebimos vino.",
          audio: "",
        },
        vosotros: {
          conjugation: "bebisteis",
          enExample: "You all drank juice.",
          esExample: "Vosotros bebisteis jugo.",
          audio: "",
        },
        ellos: {
          conjugation: "bebieron",
          enExample: "They drank beer.",
          esExample: "Ellos bebieron cerveza.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "bebía",
          enExample: "I was drinking when you called.",
          esExample: "Yo bebía cuando me llamaste.",
          audio: "",
        },
        tú: {
          conjugation: "bebías",
          enExample: "You were drinking water.",
          esExample: "Tú bebías agua.",
          audio: "",
        },
        él: {
          conjugation: "bebía",
          enExample: "He was drinking tea.",
          esExample: "Él bebía té.",
          audio: "",
        },
        nosotros: {
          conjugation: "bebíamos",
          enExample: "We were drinking coffee.",
          esExample: "Nosotros bebíamos café.",
          audio: "",
        },
        vosotros: {
          conjugation: "bebíais",
          enExample: "You all were drinking beer.",
          esExample: "Vosotros bebíais cerveza.",
          audio: "",
        },
        ellos: {
          conjugation: "bebían",
          enExample: "They were drinking wine.",
          esExample: "Ellos bebían vino.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "beberé",
          enExample: "I will drink water later.",
          esExample: "Beberé agua más tarde.",
          audio: "",
        },
        tú: {
          conjugation: "beberás",
          enExample: "You will drink juice tomorrow.",
          esExample: "Tú beberás jugo mañana.",
          audio: "",
        },
        él: {
          conjugation: "beberá",
          enExample: "He will drink milk.",
          esExample: "Él beberá leche.",
          audio: "",
        },
        nosotros: {
          conjugation: "beberemos",
          enExample: "We will drink soda.",
          esExample: "Nosotros beberemos refrescos.",
          audio: "",
        },
        vosotros: {
          conjugation: "beberéis",
          enExample: "You all will drink coffee.",
          esExample: "Vosotros beberéis café.",
          audio: "",
        },
        ellos: {
          conjugation: "beberán",
          enExample: "They will drink wine.",
          esExample: "Ellos beberán vino.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "bebería",
          enExample: "I would drink more if I were thirsty.",
          esExample: "Bebería más si tuviera sed.",
          audio: "",
        },
        tú: {
          conjugation: "beberías",
          enExample: "You would drink juice if you could.",
          esExample: "Tú beberías jugo si pudieras.",
          audio: "",
        },
        él: {
          conjugation: "bebería",
          enExample: "He would drink coffee.",
          esExample: "Él bebería café.",
          audio: "",
        },
        nosotros: {
          conjugation: "beberíamos",
          enExample: "We would drink tea.",
          esExample: "Nosotros beberíamos té.",
          audio: "",
        },
        vosotros: {
          conjugation: "beberíais",
          enExample: "You all would drink water.",
          esExample: "Vosotros beberíais agua.",
          audio: "",
        },
        ellos: {
          conjugation: "beberían",
          enExample: "They would drink beer.",
          esExample: "Ellos beberían cerveza.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "beba",
          enExample: "I hope I drink enough water.",
          esExample: "Espero que beba suficiente agua.",
          audio: "",
        },
        tú: {
          conjugation: "bebas",
          enExample: "I hope you drink tea.",
          esExample: "Espero que bebas té.",
          audio: "",
        },
        él: {
          conjugation: "beba",
          enExample: "I hope he drinks milk.",
          esExample: "Espero que él beba leche.",
          audio: "",
        },
        nosotros: {
          conjugation: "bebamos",
          enExample: "I hope we drink more water.",
          esExample: "Espero que bebamos más agua.",
          audio: "",
        },
        vosotros: {
          conjugation: "bebáis",
          enExample: "I hope you all drink enough.",
          esExample: "Espero que vosotros bebáis suficiente.",
          audio: "",
        },
        ellos: {
          conjugation: "beban",
          enExample: "I hope they drink more juice.",
          esExample: "Espero que ellos beban más jugo.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Pensar",
    en: "to think",
    conjugations: {
      present: {
        yo: {
          conjugation: "pienso",
          enExample: "I think it's a good idea.",
          esExample: "Pienso que es una buena idea.",
          audio: "",
        },
        tú: {
          conjugation: "piensas",
          enExample: "You think it's too expensive.",
          esExample: "Tú piensas que es demasiado caro.",
          audio: "",
        },
        él: {
          conjugation: "piensa",
          enExample: "He thinks it's interesting.",
          esExample: "Él piensa que es interesante.",
          audio: "",
        },
        nosotros: {
          conjugation: "pensamos",
          enExample: "We think it's going to rain.",
          esExample: "Nosotros pensamos que va a llover.",
          audio: "",
        },
        vosotros: {
          conjugation: "pensáis",
          enExample: "You all think it's a great idea.",
          esExample: "Vosotros pensáis que es una gran idea.",
          audio: "",
        },
        ellos: {
          conjugation: "piensan",
          enExample: "They think it's too late.",
          esExample: "Ellos piensan que es demasiado tarde.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "pensé",
          enExample: "I thought about it.",
          esExample: "Pensé en eso.",
          audio: "",
        },
        tú: {
          conjugation: "pensaste",
          enExample: "You thought it was a good idea.",
          esExample: "Tú pensaste que era una buena idea.",
          audio: "",
        },
        él: {
          conjugation: "pensó",
          enExample: "He thought about it all day.",
          esExample: "Él pensó en eso todo el día.",
          audio: "",
        },
        nosotros: {
          conjugation: "pensamos",
          enExample: "We thought it was too late.",
          esExample: "Nosotros pensamos que era demasiado tarde.",
          audio: "",
        },
        vosotros: {
          conjugation: "pensasteis",
          enExample: "You all thought it was easy.",
          esExample: "Vosotros pensasteis que era fácil.",
          audio: "",
        },
        ellos: {
          conjugation: "pensaron",
          enExample: "They thought the book was boring.",
          esExample: "Ellos pensaron que el libro era aburrido.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "pensaba",
          enExample: "I was thinking about the project.",
          esExample: "Yo pensaba en el proyecto.",
          audio: "",
        },
        tú: {
          conjugation: "pensabas",
          enExample: "You were thinking about the past.",
          esExample: "Tú pensabas en el pasado.",
          audio: "",
        },
        él: {
          conjugation: "pensaba",
          enExample: "He was thinking about the exam.",
          esExample: "Él pensaba en el examen.",
          audio: "",
        },
        nosotros: {
          conjugation: "pensábamos",
          enExample: "We were thinking about our options.",
          esExample: "Nosotros pensábamos en nuestras opciones.",
          audio: "",
        },
        vosotros: {
          conjugation: "pensabais",
          enExample: "You all were thinking of leaving.",
          esExample: "Vosotros pensabais en irse.",
          audio: "",
        },
        ellos: {
          conjugation: "pensaban",
          enExample: "They were thinking about their future.",
          esExample: "Ellos pensaban en su futuro.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "pensaré",
          enExample: "I will think about it tomorrow.",
          esExample: "Pensaré en eso mañana.",
          audio: "",
        },
        tú: {
          conjugation: "pensarás",
          enExample: "You will think it's a good idea.",
          esExample: "Tú pensarás que es una buena idea.",
          audio: "",
        },
        él: {
          conjugation: "pensará",
          enExample: "He will think it's too late.",
          esExample: "Él pensará que es demasiado tarde.",
          audio: "",
        },
        nosotros: {
          conjugation: "pensaremos",
          enExample: "We will think about the consequences.",
          esExample: "Nosotros pensaremos en las consecuencias.",
          audio: "",
        },
        vosotros: {
          conjugation: "pensaréis",
          enExample: "You all will think it's easy.",
          esExample: "Vosotros pensaréis que es fácil.",
          audio: "",
        },
        ellos: {
          conjugation: "pensarán",
          enExample: "They will think it's a good idea.",
          esExample: "Ellos pensarán que es una buena idea.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "pensaría",
          enExample: "I would think about it if I had time.",
          esExample: "Pensaría en eso si tuviera tiempo.",
          audio: "",
        },
        tú: {
          conjugation: "pensarías",
          enExample: "You would think it's a great idea.",
          esExample: "Tú pensarías que es una gran idea.",
          audio: "",
        },
        él: {
          conjugation: "pensaría",
          enExample: "He would think it's a good opportunity.",
          esExample: "Él pensaría que es una buena oportunidad.",
          audio: "",
        },
        nosotros: {
          conjugation: "pensaríamos",
          enExample: "We would think it's worth it.",
          esExample: "Nosotros pensaríamos que vale la pena.",
          audio: "",
        },
        vosotros: {
          conjugation: "pensaríais",
          enExample: "You all would think it's funny.",
          esExample: "Vosotros pensaríais que es gracioso.",
          audio: "",
        },
        ellos: {
          conjugation: "pensarían",
          enExample: "They would think it's possible.",
          esExample: "Ellos pensarían que es posible.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "piense",
          enExample: "I hope I think of a solution.",
          esExample: "Espero que piense en una solución.",
          audio: "",
        },
        tú: {
          conjugation: "pienses",
          enExample: "I hope you think it's a good idea.",
          esExample: "Espero que tú pienses que es una buena idea.",
          audio: "",
        },
        él: {
          conjugation: "piense",
          enExample: "I hope he thinks it's important.",
          esExample: "Espero que él piense que es importante.",
          audio: "",
        },
        nosotros: {
          conjugation: "pensemos",
          enExample: "I hope we think together.",
          esExample: "Espero que pensemos juntos.",
          audio: "",
        },
        vosotros: {
          conjugation: "penséis",
          enExample: "I hope you all think about it.",
          esExample: "Espero que vosotros penséis en eso.",
          audio: "",
        },
        ellos: {
          conjugation: "piensen",
          enExample: "I hope they think it's a good idea.",
          esExample: "Espero que ellos piensen que es una buena idea.",
          audio: "",
        },
      },
    },
  },
  {
    name: "Creer",
    en: "to believe/to think",
    conjugations: {
      present: {
        yo: {
          conjugation: "creo",
          enExample: "I believe it's true.",
          esExample: "Creo que es cierto.",
          audio: "",
        },
        tú: {
          conjugation: "crees",
          enExample: "You believe in science.",
          esExample: "Tú crees en la ciencia.",
          audio: "",
        },
        él: {
          conjugation: "cree",
          enExample: "He believes in God.",
          esExample: "Él cree en Dios.",
          audio: "",
        },
        nosotros: {
          conjugation: "creemos",
          enExample: "We believe in equality.",
          esExample: "Nosotros creemos en la igualdad.",
          audio: "",
        },
        vosotros: {
          conjugation: "creéis",
          enExample: "You all believe in democracy.",
          esExample: "Vosotros creéis en la democracia.",
          audio: "",
        },
        ellos: {
          conjugation: "creen",
          enExample: "They believe it's a good idea.",
          esExample: "Ellos creen que es una buena idea.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "creí",
          enExample: "I thought it was a good idea.",
          esExample: "Creí que era una buena idea.",
          audio: "",
        },
        tú: {
          conjugation: "creíste",
          enExample: "You believed in me.",
          esExample: "Tú creíste en mí.",
          audio: "",
        },
        él: {
          conjugation: "creyó",
          enExample: "He believed it was right.",
          esExample: "Él creyó que estaba bien.",
          audio: "",
        },
        nosotros: {
          conjugation: "creímos",
          enExample: "We believed in justice.",
          esExample: "Nosotros creímos en la justicia.",
          audio: "",
        },
        vosotros: {
          conjugation: "creísteis",
          enExample: "You all believed in the project.",
          esExample: "Vosotros creísteis en el proyecto.",
          audio: "",
        },
        ellos: {
          conjugation: "creyeron",
          enExample: "They believed the rumors.",
          esExample: "Ellos creyeron los rumores.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "creía",
          enExample: "I used to think it was a good idea.",
          esExample: "Yo creía que era una buena idea.",
          audio: "",
        },
        tú: {
          conjugation: "creías",
          enExample: "You used to believe in magic.",
          esExample: "Tú creías en la magia.",
          audio: "",
        },
        él: {
          conjugation: "creía",
          enExample: "He believed it was the right thing to do.",
          esExample: "Él creía que era lo correcto.",
          audio: "",
        },
        nosotros: {
          conjugation: "creíamos",
          enExample: "We used to believe in love.",
          esExample: "Nosotros creíamos en el amor.",
          audio: "",
        },
        vosotros: {
          conjugation: "creíais",
          enExample: "You all used to believe in that.",
          esExample: "Vosotros creíais en eso.",
          audio: "",
        },
        ellos: {
          conjugation: "creían",
          enExample: "They used to believe in fairy tales.",
          esExample: "Ellos creían en los cuentos de hadas.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "creeré",
          enExample: "I will believe you.",
          esExample: "Yo creeré en ti.",
          audio: "",
        },
        tú: {
          conjugation: "creerás",
          enExample: "You will believe it's true.",
          esExample: "Tú creerás que es cierto.",
          audio: "",
        },
        él: {
          conjugation: "creerá",
          enExample: "He will believe in himself.",
          esExample: "Él creerá en sí mismo.",
          audio: "",
        },
        nosotros: {
          conjugation: "creeremos",
          enExample: "We will believe in freedom.",
          esExample: "Nosotros creeremos en la libertad.",
          audio: "",
        },
        vosotros: {
          conjugation: "creeréis",
          enExample: "You all will believe in the project.",
          esExample: "Vosotros creeréis en el proyecto.",
          audio: "",
        },
        ellos: {
          conjugation: "creerán",
          enExample: "They will believe the news.",
          esExample: "Ellos creerán las noticias.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "creería",
          enExample: "I would believe if I saw it.",
          esExample: "Creería si lo viera.",
          audio: "",
        },
        tú: {
          conjugation: "creerías",
          enExample: "You would believe it too.",
          esExample: "Tú creerías en eso también.",
          audio: "",
        },
        él: {
          conjugation: "creería",
          enExample: "He would believe if he knew the truth.",
          esExample: "Él creería si supiera la verdad.",
          audio: "",
        },
        nosotros: {
          conjugation: "creeríamos",
          enExample: "We would believe in it if we had proof.",
          esExample: "Nosotros creeríamos en eso si tuviéramos pruebas.",
          audio: "",
        },
        vosotros: {
          conjugation: "creeríais",
          enExample: "You all would believe if you saw it.",
          esExample: "Vosotros creeríais si lo vierais.",
          audio: "",
        },
        ellos: {
          conjugation: "creerían",
          enExample: "They would believe if they heard the story.",
          esExample: "Ellos creerían si escucharan la historia.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "crea",
          enExample: "I hope I believe in the solution.",
          esExample: "Espero que crea en la solución.",
          audio: "",
        },
        tú: {
          conjugation: "creas",
          enExample: "I hope you believe in yourself.",
          esExample: "Espero que tú creas en ti mismo.",
          audio: "",
        },
        él: {
          conjugation: "crea",
          enExample: "I hope he believes in the cause.",
          esExample: "Espero que él crea en la causa.",
          audio: "",
        },
        nosotros: {
          conjugation: "creamos",
          enExample: "I hope we believe in each other.",
          esExample: "Espero que creamos en nosotros.",
          audio: "",
        },
        vosotros: {
          conjugation: "creáis",
          enExample: "I hope you all believe in the future.",
          esExample: "Espero que vosotros creáis en el futuro.",
          audio: "",
        },
        ellos: {
          conjugation: "crean",
          enExample: "I hope they believe in the truth.",
          esExample: "Espero que ellos crean en la verdad.",
          audio: "",
        },
      },
    },
  },{
    name: "Tomar",
    en: "to take",
    conjugations: {
      present: {
        yo: {
          conjugation: "tomo",
          enExample: "I take the bus every day.",
          esExample: "Yo tomo el autobús todos los días.",
          audio: "",
        },
        tú: {
          conjugation: "tomas",
          enExample: "You take a walk every morning.",
          esExample: "Tú tomas un paseo cada mañana.",
          audio: "",
        },
        él: {
          conjugation: "toma",
          enExample: "He takes the train to work.",
          esExample: "Él toma el tren al trabajo.",
          audio: "",
        },
        nosotros: {
          conjugation: "tomamos",
          enExample: "We take a break at noon.",
          esExample: "Nosotros tomamos un descanso al mediodía.",
          audio: "",
        },
        vosotros: {
          conjugation: "tomáis",
          enExample: "You all take the same route.",
          esExample: "Vosotros tomáis la misma ruta.",
          audio: "",
        },
        ellos: {
          conjugation: "toman",
          enExample: "They take their time when working.",
          esExample: "Ellos toman su tiempo cuando trabajan.",
          audio: "",
        },
      },
      preterite: {
        yo: {
          conjugation: "tomé",
          enExample: "I took the book home.",
          esExample: "Yo tomé el libro a casa.",
          audio: "",
        },
        tú: {
          conjugation: "tomaste",
          enExample: "You took the wrong turn.",
          esExample: "Tú tomaste el giro equivocado.",
          audio: "",
        },
        él: {
          conjugation: "tomó",
          enExample: "He took a nap yesterday.",
          esExample: "Él tomó una siesta ayer.",
          audio: "",
        },
        nosotros: {
          conjugation: "tomamos",
          enExample: "We took the bus last week.",
          esExample: "Nosotros tomamos el autobús la semana pasada.",
          audio: "",
        },
        vosotros: {
          conjugation: "tomasteis",
          enExample: "You all took the trip to Madrid.",
          esExample: "Vosotros tomasteis el viaje a Madrid.",
          audio: "",
        },
        ellos: {
          conjugation: "tomaron",
          enExample: "They took the opportunity to learn.",
          esExample: "Ellos tomaron la oportunidad de aprender.",
          audio: "",
        },
      },
      imperfect: {
        yo: {
          conjugation: "tomaba",
          enExample: "I was taking notes during the lecture.",
          esExample: "Yo tomaba notas durante la conferencia.",
          audio: "",
        },
        tú: {
          conjugation: "tomabas",
          enExample: "You were taking it easy.",
          esExample: "Tú tomabas las cosas con calma.",
          audio: "",
        },
        él: {
          conjugation: "tomaba",
          enExample: "He was taking the class seriously.",
          esExample: "Él tomaba la clase en serio.",
          audio: "",
        },
        nosotros: {
          conjugation: "tomábamos",
          enExample: "We were taking turns.",
          esExample: "Nosotros tomábamos turnos.",
          audio: "",
        },
        vosotros: {
          conjugation: "tomabais",
          enExample: "You all were taking the same path.",
          esExample: "Vosotros tomabais el mismo camino.",
          audio: "",
        },
        ellos: {
          conjugation: "tomaban",
          enExample: "They were taking the decision slowly.",
          esExample: "Ellos tomaban la decisión lentamente.",
          audio: "",
        },
      },
      future: {
        yo: {
          conjugation: "tomaré",
          enExample: "I will take the medicine tomorrow.",
          esExample: "Yo tomaré la medicina mañana.",
          audio: "",
        },
        tú: {
          conjugation: "tomarás",
          enExample: "You will take the exam next week.",
          esExample: "Tú tomarás el examen la próxima semana.",
          audio: "",
        },
        él: {
          conjugation: "tomará",
          enExample: "He will take the responsibility.",
          esExample: "Él tomará la responsabilidad.",
          audio: "",
        },
        nosotros: {
          conjugation: "tomaremos",
          enExample: "We will take action after the meeting.",
          esExample: "Nosotros tomaremos acción después de la reunión.",
          audio: "",
        },
        vosotros: {
          conjugation: "tomaréis",
          enExample: "You all will take a trip next summer.",
          esExample: "Vosotros tomaréis un viaje el próximo verano.",
          audio: "",
        },
        ellos: {
          conjugation: "tomarán",
          enExample: "They will take care of it later.",
          esExample: "Ellos tomarán cuidado de ello más tarde.",
          audio: "",
        },
      },
      conditional: {
        yo: {
          conjugation: "tomaría",
          enExample: "I would take the offer if it were better.",
          esExample: "Yo tomaría la oferta si fuera mejor.",
          audio: "",
        },
        tú: {
          conjugation: "tomarías",
          enExample: "You would take a break if you had time.",
          esExample: "Tú tomarías un descanso si tuvieras tiempo.",
          audio: "",
        },
        él: {
          conjugation: "tomaría",
          enExample: "He would take the challenge if asked.",
          esExample: "Él tomaría el reto si se le pidiera.",
          audio: "",
        },
        nosotros: {
          conjugation: "tomaríamos",
          enExample: "We would take the offer if possible.",
          esExample: "Nosotros tomaríamos la oferta si fuera posible.",
          audio: "",
        },
        vosotros: {
          conjugation: "tomaríais",
          enExample: "You all would take the risk if needed.",
          esExample: "Vosotros tomaríais el riesgo si fuera necesario.",
          audio: "",
        },
        ellos: {
          conjugation: "tomarían",
          enExample: "They would take care of it if they could.",
          esExample: "Ellos tomarían cuidado de ello si pudieran.",
          audio: "",
        },
      },
      subjunctive: {
        yo: {
          conjugation: "tome",
          enExample: "I hope I take the opportunity.",
          esExample: "Espero que tome la oportunidad.",
          audio: "",
        },
        tú: {
          conjugation: "tomes",
          enExample: "I hope you take care of it.",
          esExample: "Espero que tomes cuidado de ello.",
          audio: "",
        },
        él: {
          conjugation: "tome",
          enExample: "I hope he takes the time to help.",
          esExample: "Espero que él tome el tiempo para ayudar.",
          audio: "",
        },
        nosotros: {
          conjugation: "tomemos",
          enExample: "I hope we take action soon.",
          esExample: "Espero que tomemos acción pronto.",
          audio: "",
        },
        vosotros: {
          conjugation: "toméis",
          enExample: "I hope you all take the opportunity.",
          esExample: "Espero que vosotros toméis la oportunidad.",
          audio: "",
        },
        ellos: {
          conjugation: "tomen",
          enExample: "I hope they take care of the situation.",
          esExample: "Espero que ellos tomen cuidado de la situación.",
          audio: "",
        },
      },
    },
  }  
];


// const esExamplesWithKeys = verbs.flatMap(verb =>
//   Object.entries(verb.conjugations).flatMap(([tense, pronouns]) =>
//     Object.entries(pronouns).map(([pronoun, conjugation]) => {
//       const key = `${verb.name}_${tense}_${pronoun}`;
//       return { [key]: conjugation.esExample };
//     })
//   )
// );

// const esExamplesObject = data.reduce((acc, verb) => {
//   Object.entries(verb.conjugations).forEach(([tense, pronouns]) => {
//     Object.entries(pronouns).forEach(([pronoun, conjugation]) => {
//       const key = `${verb.name}_${tense}_${pronoun}`;
//       acc[key] = conjugation.esExample;
//     });
//   });
//   return acc;
// }, {});